import { jsxs as x, jsx as l, Fragment as We } from "react/jsx-runtime";
import { useState as ye } from "react";
var N;
(function(a) {
  a.assertEqual = (n) => {
  };
  function e(n) {
  }
  a.assertIs = e;
  function t(n) {
    throw new Error();
  }
  a.assertNever = t, a.arrayToEnum = (n) => {
    const s = {};
    for (const i of n)
      s[i] = i;
    return s;
  }, a.getValidEnumValues = (n) => {
    const s = a.objectKeys(n).filter((o) => typeof n[n[o]] != "number"), i = {};
    for (const o of s)
      i[o] = n[o];
    return a.objectValues(i);
  }, a.objectValues = (n) => a.objectKeys(n).map(function(s) {
    return n[s];
  }), a.objectKeys = typeof Object.keys == "function" ? (n) => Object.keys(n) : (n) => {
    const s = [];
    for (const i in n)
      Object.prototype.hasOwnProperty.call(n, i) && s.push(i);
    return s;
  }, a.find = (n, s) => {
    for (const i of n)
      if (s(i))
        return i;
  }, a.isInteger = typeof Number.isInteger == "function" ? (n) => Number.isInteger(n) : (n) => typeof n == "number" && Number.isFinite(n) && Math.floor(n) === n;
  function r(n, s = " | ") {
    return n.map((i) => typeof i == "string" ? `'${i}'` : i).join(s);
  }
  a.joinValues = r, a.jsonStringifyReplacer = (n, s) => typeof s == "bigint" ? s.toString() : s;
})(N || (N = {}));
var ve;
(function(a) {
  a.mergeShapes = (e, t) => ({
    ...e,
    ...t
    // second overwrites first
  });
})(ve || (ve = {}));
const h = N.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), L = (a) => {
  switch (typeof a) {
    case "undefined":
      return h.undefined;
    case "string":
      return h.string;
    case "number":
      return Number.isNaN(a) ? h.nan : h.number;
    case "boolean":
      return h.boolean;
    case "function":
      return h.function;
    case "bigint":
      return h.bigint;
    case "symbol":
      return h.symbol;
    case "object":
      return Array.isArray(a) ? h.array : a === null ? h.null : a.then && typeof a.then == "function" && a.catch && typeof a.catch == "function" ? h.promise : typeof Map < "u" && a instanceof Map ? h.map : typeof Set < "u" && a instanceof Set ? h.set : typeof Date < "u" && a instanceof Date ? h.date : h.object;
    default:
      return h.unknown;
  }
}, d = N.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class V extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (r) => {
      this.issues = [...this.issues, r];
    }, this.addIssues = (r = []) => {
      this.issues = [...this.issues, ...r];
    };
    const t = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, t) : this.__proto__ = t, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const t = e || function(s) {
      return s.message;
    }, r = { _errors: [] }, n = (s) => {
      for (const i of s.issues)
        if (i.code === "invalid_union")
          i.unionErrors.map(n);
        else if (i.code === "invalid_return_type")
          n(i.returnTypeError);
        else if (i.code === "invalid_arguments")
          n(i.argumentsError);
        else if (i.path.length === 0)
          r._errors.push(t(i));
        else {
          let o = r, u = 0;
          for (; u < i.path.length; ) {
            const m = i.path[u];
            u === i.path.length - 1 ? (o[m] = o[m] || { _errors: [] }, o[m]._errors.push(t(i))) : o[m] = o[m] || { _errors: [] }, o = o[m], u++;
          }
        }
    };
    return n(this), r;
  }
  static assert(e) {
    if (!(e instanceof V))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, N.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (t) => t.message) {
    const t = {}, r = [];
    for (const n of this.issues)
      if (n.path.length > 0) {
        const s = n.path[0];
        t[s] = t[s] || [], t[s].push(e(n));
      } else
        r.push(e(n));
    return { formErrors: r, fieldErrors: t };
  }
  get formErrors() {
    return this.flatten();
  }
}
V.create = (a) => new V(a);
const de = (a, e) => {
  let t;
  switch (a.code) {
    case d.invalid_type:
      a.received === h.undefined ? t = "Required" : t = `Expected ${a.expected}, received ${a.received}`;
      break;
    case d.invalid_literal:
      t = `Invalid literal value, expected ${JSON.stringify(a.expected, N.jsonStringifyReplacer)}`;
      break;
    case d.unrecognized_keys:
      t = `Unrecognized key(s) in object: ${N.joinValues(a.keys, ", ")}`;
      break;
    case d.invalid_union:
      t = "Invalid input";
      break;
    case d.invalid_union_discriminator:
      t = `Invalid discriminator value. Expected ${N.joinValues(a.options)}`;
      break;
    case d.invalid_enum_value:
      t = `Invalid enum value. Expected ${N.joinValues(a.options)}, received '${a.received}'`;
      break;
    case d.invalid_arguments:
      t = "Invalid function arguments";
      break;
    case d.invalid_return_type:
      t = "Invalid function return type";
      break;
    case d.invalid_date:
      t = "Invalid date";
      break;
    case d.invalid_string:
      typeof a.validation == "object" ? "includes" in a.validation ? (t = `Invalid input: must include "${a.validation.includes}"`, typeof a.validation.position == "number" && (t = `${t} at one or more positions greater than or equal to ${a.validation.position}`)) : "startsWith" in a.validation ? t = `Invalid input: must start with "${a.validation.startsWith}"` : "endsWith" in a.validation ? t = `Invalid input: must end with "${a.validation.endsWith}"` : N.assertNever(a.validation) : a.validation !== "regex" ? t = `Invalid ${a.validation}` : t = "Invalid";
      break;
    case d.too_small:
      a.type === "array" ? t = `Array must contain ${a.exact ? "exactly" : a.inclusive ? "at least" : "more than"} ${a.minimum} element(s)` : a.type === "string" ? t = `String must contain ${a.exact ? "exactly" : a.inclusive ? "at least" : "over"} ${a.minimum} character(s)` : a.type === "number" ? t = `Number must be ${a.exact ? "exactly equal to " : a.inclusive ? "greater than or equal to " : "greater than "}${a.minimum}` : a.type === "bigint" ? t = `Number must be ${a.exact ? "exactly equal to " : a.inclusive ? "greater than or equal to " : "greater than "}${a.minimum}` : a.type === "date" ? t = `Date must be ${a.exact ? "exactly equal to " : a.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(a.minimum))}` : t = "Invalid input";
      break;
    case d.too_big:
      a.type === "array" ? t = `Array must contain ${a.exact ? "exactly" : a.inclusive ? "at most" : "less than"} ${a.maximum} element(s)` : a.type === "string" ? t = `String must contain ${a.exact ? "exactly" : a.inclusive ? "at most" : "under"} ${a.maximum} character(s)` : a.type === "number" ? t = `Number must be ${a.exact ? "exactly" : a.inclusive ? "less than or equal to" : "less than"} ${a.maximum}` : a.type === "bigint" ? t = `BigInt must be ${a.exact ? "exactly" : a.inclusive ? "less than or equal to" : "less than"} ${a.maximum}` : a.type === "date" ? t = `Date must be ${a.exact ? "exactly" : a.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(a.maximum))}` : t = "Invalid input";
      break;
    case d.custom:
      t = "Invalid input";
      break;
    case d.invalid_intersection_types:
      t = "Intersection results could not be merged";
      break;
    case d.not_multiple_of:
      t = `Number must be a multiple of ${a.multipleOf}`;
      break;
    case d.not_finite:
      t = "Number must be finite";
      break;
    default:
      t = e.defaultError, N.assertNever(a);
  }
  return { message: t };
};
let De = de;
function qe() {
  return De;
}
const Ue = (a) => {
  const { data: e, path: t, errorMaps: r, issueData: n } = a, s = [...t, ...n.path || []], i = {
    ...n,
    path: s
  };
  if (n.message !== void 0)
    return {
      ...n,
      path: s,
      message: n.message
    };
  let o = "";
  const u = r.filter((m) => !!m).slice().reverse();
  for (const m of u)
    o = m(i, { data: e, defaultError: o }).message;
  return {
    ...n,
    path: s,
    message: o
  };
};
function f(a, e) {
  const t = qe(), r = Ue({
    issueData: e,
    data: a.data,
    path: a.path,
    errorMaps: [
      a.common.contextualErrorMap,
      // contextual error map is first priority
      a.schemaErrorMap,
      // then schema-bound map if available
      t,
      // then global override map
      t === de ? void 0 : de
      // then global default map
    ].filter((n) => !!n)
  });
  a.common.issues.push(r);
}
class I {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, t) {
    const r = [];
    for (const n of t) {
      if (n.status === "aborted")
        return y;
      n.status === "dirty" && e.dirty(), r.push(n.value);
    }
    return { status: e.value, value: r };
  }
  static async mergeObjectAsync(e, t) {
    const r = [];
    for (const n of t) {
      const s = await n.key, i = await n.value;
      r.push({
        key: s,
        value: i
      });
    }
    return I.mergeObjectSync(e, r);
  }
  static mergeObjectSync(e, t) {
    const r = {};
    for (const n of t) {
      const { key: s, value: i } = n;
      if (s.status === "aborted" || i.status === "aborted")
        return y;
      s.status === "dirty" && e.dirty(), i.status === "dirty" && e.dirty(), s.value !== "__proto__" && (typeof i.value < "u" || n.alwaysSet) && (r[s.value] = i.value);
    }
    return { status: e.value, value: r };
  }
}
const y = Object.freeze({
  status: "aborted"
}), ee = (a) => ({ status: "dirty", value: a }), Z = (a) => ({ status: "valid", value: a }), xe = (a) => a.status === "aborted", be = (a) => a.status === "dirty", H = (a) => a.status === "valid", re = (a) => typeof Promise < "u" && a instanceof Promise;
var p;
(function(a) {
  a.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, a.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(p || (p = {}));
class B {
  constructor(e, t, r, n) {
    this._cachedPath = [], this.parent = e, this.data = t, this._path = r, this._key = n;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const _e = (a, e) => {
  if (H(e))
    return { success: !0, data: e.value };
  if (!a.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const t = new V(a.common.issues);
      return this._error = t, this._error;
    }
  };
};
function b(a) {
  if (!a)
    return {};
  const { errorMap: e, invalid_type_error: t, required_error: r, description: n } = a;
  if (e && (t || r))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: n } : { errorMap: (i, o) => {
    const { message: u } = a;
    return i.code === "invalid_enum_value" ? { message: u ?? o.defaultError } : typeof o.data > "u" ? { message: u ?? r ?? o.defaultError } : i.code !== "invalid_type" ? { message: o.defaultError } : { message: u ?? t ?? o.defaultError };
  }, description: n };
}
class k {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return L(e.data);
  }
  _getOrReturnCtx(e, t) {
    return t || {
      common: e.parent.common,
      data: e.data,
      parsedType: L(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new I(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: L(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const t = this._parse(e);
    if (re(t))
      throw new Error("Synchronous parse encountered promise.");
    return t;
  }
  _parseAsync(e) {
    const t = this._parse(e);
    return Promise.resolve(t);
  }
  parse(e, t) {
    const r = this.safeParse(e, t);
    if (r.success)
      return r.data;
    throw r.error;
  }
  safeParse(e, t) {
    const r = {
      common: {
        issues: [],
        async: (t == null ? void 0 : t.async) ?? !1,
        contextualErrorMap: t == null ? void 0 : t.errorMap
      },
      path: (t == null ? void 0 : t.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: L(e)
    }, n = this._parseSync({ data: e, path: r.path, parent: r });
    return _e(r, n);
  }
  "~validate"(e) {
    var r, n;
    const t = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: L(e)
    };
    if (!this["~standard"].async)
      try {
        const s = this._parseSync({ data: e, path: [], parent: t });
        return H(s) ? {
          value: s.value
        } : {
          issues: t.common.issues
        };
      } catch (s) {
        (n = (r = s == null ? void 0 : s.message) == null ? void 0 : r.toLowerCase()) != null && n.includes("encountered") && (this["~standard"].async = !0), t.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: t }).then((s) => H(s) ? {
      value: s.value
    } : {
      issues: t.common.issues
    });
  }
  async parseAsync(e, t) {
    const r = await this.safeParseAsync(e, t);
    if (r.success)
      return r.data;
    throw r.error;
  }
  async safeParseAsync(e, t) {
    const r = {
      common: {
        issues: [],
        contextualErrorMap: t == null ? void 0 : t.errorMap,
        async: !0
      },
      path: (t == null ? void 0 : t.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: L(e)
    }, n = this._parse({ data: e, path: r.path, parent: r }), s = await (re(n) ? n : Promise.resolve(n));
    return _e(r, s);
  }
  refine(e, t) {
    const r = (n) => typeof t == "string" || typeof t > "u" ? { message: t } : typeof t == "function" ? t(n) : t;
    return this._refinement((n, s) => {
      const i = e(n), o = () => s.addIssue({
        code: d.custom,
        ...r(n)
      });
      return typeof Promise < "u" && i instanceof Promise ? i.then((u) => u ? !0 : (o(), !1)) : i ? !0 : (o(), !1);
    });
  }
  refinement(e, t) {
    return this._refinement((r, n) => e(r) ? !0 : (n.addIssue(typeof t == "function" ? t(r, n) : t), !1));
  }
  _refinement(e) {
    return new Q({
      schema: this,
      typeName: v.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (t) => this["~validate"](t)
    };
  }
  optional() {
    return M.create(this, this._def);
  }
  nullable() {
    return X.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return j.create(this);
  }
  promise() {
    return oe.create(this, this._def);
  }
  or(e) {
    return se.create([this, e], this._def);
  }
  and(e) {
    return ie.create(this, e, this._def);
  }
  transform(e) {
    return new Q({
      ...b(this._def),
      schema: this,
      typeName: v.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const t = typeof e == "function" ? e : () => e;
    return new me({
      ...b(this._def),
      innerType: this,
      defaultValue: t,
      typeName: v.ZodDefault
    });
  }
  brand() {
    return new pt({
      typeName: v.ZodBranded,
      type: this,
      ...b(this._def)
    });
  }
  catch(e) {
    const t = typeof e == "function" ? e : () => e;
    return new fe({
      ...b(this._def),
      innerType: this,
      catchValue: t,
      typeName: v.ZodCatch
    });
  }
  describe(e) {
    const t = this.constructor;
    return new t({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return pe.create(this, e);
  }
  readonly() {
    return he.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const Ge = /^c[^\s-]{8,}$/i, He = /^[0-9a-z]+$/, Ye = /^[0-9A-HJKMNP-TV-Z]{26}$/i, Je = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Qe = /^[a-z0-9_-]{21}$/i, Xe = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, Ke = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, et = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, tt = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let le;
const at = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, rt = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, nt = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, st = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, it = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, ot = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, $e = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", lt = new RegExp(`^${$e}$`);
function Ee(a) {
  let e = "[0-5]\\d";
  a.precision ? e = `${e}\\.\\d{${a.precision}}` : a.precision == null && (e = `${e}(\\.\\d+)?`);
  const t = a.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${e})${t}`;
}
function dt(a) {
  return new RegExp(`^${Ee(a)}$`);
}
function ct(a) {
  let e = `${$e}T${Ee(a)}`;
  const t = [];
  return t.push(a.local ? "Z?" : "Z"), a.offset && t.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${t.join("|")})`, new RegExp(`^${e}$`);
}
function ut(a, e) {
  return !!((e === "v4" || !e) && at.test(a) || (e === "v6" || !e) && nt.test(a));
}
function mt(a, e) {
  if (!Xe.test(a))
    return !1;
  try {
    const [t] = a.split(".");
    if (!t)
      return !1;
    const r = t.replace(/-/g, "+").replace(/_/g, "/").padEnd(t.length + (4 - t.length % 4) % 4, "="), n = JSON.parse(atob(r));
    return !(typeof n != "object" || n === null || "typ" in n && (n == null ? void 0 : n.typ) !== "JWT" || !n.alg || e && n.alg !== e);
  } catch {
    return !1;
  }
}
function ft(a, e) {
  return !!((e === "v4" || !e) && rt.test(a) || (e === "v6" || !e) && st.test(a));
}
class P extends k {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== h.string) {
      const s = this._getOrReturnCtx(e);
      return f(s, {
        code: d.invalid_type,
        expected: h.string,
        received: s.parsedType
      }), y;
    }
    const r = new I();
    let n;
    for (const s of this._def.checks)
      if (s.kind === "min")
        e.data.length < s.value && (n = this._getOrReturnCtx(e, n), f(n, {
          code: d.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), r.dirty());
      else if (s.kind === "max")
        e.data.length > s.value && (n = this._getOrReturnCtx(e, n), f(n, {
          code: d.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), r.dirty());
      else if (s.kind === "length") {
        const i = e.data.length > s.value, o = e.data.length < s.value;
        (i || o) && (n = this._getOrReturnCtx(e, n), i ? f(n, {
          code: d.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }) : o && f(n, {
          code: d.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }), r.dirty());
      } else if (s.kind === "email")
        et.test(e.data) || (n = this._getOrReturnCtx(e, n), f(n, {
          validation: "email",
          code: d.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "emoji")
        le || (le = new RegExp(tt, "u")), le.test(e.data) || (n = this._getOrReturnCtx(e, n), f(n, {
          validation: "emoji",
          code: d.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "uuid")
        Je.test(e.data) || (n = this._getOrReturnCtx(e, n), f(n, {
          validation: "uuid",
          code: d.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "nanoid")
        Qe.test(e.data) || (n = this._getOrReturnCtx(e, n), f(n, {
          validation: "nanoid",
          code: d.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "cuid")
        Ge.test(e.data) || (n = this._getOrReturnCtx(e, n), f(n, {
          validation: "cuid",
          code: d.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "cuid2")
        He.test(e.data) || (n = this._getOrReturnCtx(e, n), f(n, {
          validation: "cuid2",
          code: d.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "ulid")
        Ye.test(e.data) || (n = this._getOrReturnCtx(e, n), f(n, {
          validation: "ulid",
          code: d.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "url")
        try {
          new URL(e.data);
        } catch {
          n = this._getOrReturnCtx(e, n), f(n, {
            validation: "url",
            code: d.invalid_string,
            message: s.message
          }), r.dirty();
        }
      else s.kind === "regex" ? (s.regex.lastIndex = 0, s.regex.test(e.data) || (n = this._getOrReturnCtx(e, n), f(n, {
        validation: "regex",
        code: d.invalid_string,
        message: s.message
      }), r.dirty())) : s.kind === "trim" ? e.data = e.data.trim() : s.kind === "includes" ? e.data.includes(s.value, s.position) || (n = this._getOrReturnCtx(e, n), f(n, {
        code: d.invalid_string,
        validation: { includes: s.value, position: s.position },
        message: s.message
      }), r.dirty()) : s.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : s.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : s.kind === "startsWith" ? e.data.startsWith(s.value) || (n = this._getOrReturnCtx(e, n), f(n, {
        code: d.invalid_string,
        validation: { startsWith: s.value },
        message: s.message
      }), r.dirty()) : s.kind === "endsWith" ? e.data.endsWith(s.value) || (n = this._getOrReturnCtx(e, n), f(n, {
        code: d.invalid_string,
        validation: { endsWith: s.value },
        message: s.message
      }), r.dirty()) : s.kind === "datetime" ? ct(s).test(e.data) || (n = this._getOrReturnCtx(e, n), f(n, {
        code: d.invalid_string,
        validation: "datetime",
        message: s.message
      }), r.dirty()) : s.kind === "date" ? lt.test(e.data) || (n = this._getOrReturnCtx(e, n), f(n, {
        code: d.invalid_string,
        validation: "date",
        message: s.message
      }), r.dirty()) : s.kind === "time" ? dt(s).test(e.data) || (n = this._getOrReturnCtx(e, n), f(n, {
        code: d.invalid_string,
        validation: "time",
        message: s.message
      }), r.dirty()) : s.kind === "duration" ? Ke.test(e.data) || (n = this._getOrReturnCtx(e, n), f(n, {
        validation: "duration",
        code: d.invalid_string,
        message: s.message
      }), r.dirty()) : s.kind === "ip" ? ut(e.data, s.version) || (n = this._getOrReturnCtx(e, n), f(n, {
        validation: "ip",
        code: d.invalid_string,
        message: s.message
      }), r.dirty()) : s.kind === "jwt" ? mt(e.data, s.alg) || (n = this._getOrReturnCtx(e, n), f(n, {
        validation: "jwt",
        code: d.invalid_string,
        message: s.message
      }), r.dirty()) : s.kind === "cidr" ? ft(e.data, s.version) || (n = this._getOrReturnCtx(e, n), f(n, {
        validation: "cidr",
        code: d.invalid_string,
        message: s.message
      }), r.dirty()) : s.kind === "base64" ? it.test(e.data) || (n = this._getOrReturnCtx(e, n), f(n, {
        validation: "base64",
        code: d.invalid_string,
        message: s.message
      }), r.dirty()) : s.kind === "base64url" ? ot.test(e.data) || (n = this._getOrReturnCtx(e, n), f(n, {
        validation: "base64url",
        code: d.invalid_string,
        message: s.message
      }), r.dirty()) : N.assertNever(s);
    return { status: r.value, value: e.data };
  }
  _regex(e, t, r) {
    return this.refinement((n) => e.test(n), {
      validation: t,
      code: d.invalid_string,
      ...p.errToObj(r)
    });
  }
  _addCheck(e) {
    return new P({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...p.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...p.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...p.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...p.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...p.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...p.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...p.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...p.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...p.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...p.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...p.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...p.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...p.errToObj(e) });
  }
  datetime(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (e == null ? void 0 : e.offset) ?? !1,
      local: (e == null ? void 0 : e.local) ?? !1,
      ...p.errToObj(e == null ? void 0 : e.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      ...p.errToObj(e == null ? void 0 : e.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...p.errToObj(e) });
  }
  regex(e, t) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...p.errToObj(t)
    });
  }
  includes(e, t) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: t == null ? void 0 : t.position,
      ...p.errToObj(t == null ? void 0 : t.message)
    });
  }
  startsWith(e, t) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...p.errToObj(t)
    });
  }
  endsWith(e, t) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...p.errToObj(t)
    });
  }
  min(e, t) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...p.errToObj(t)
    });
  }
  max(e, t) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...p.errToObj(t)
    });
  }
  length(e, t) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...p.errToObj(t)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, p.errToObj(e));
  }
  trim() {
    return new P({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new P({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new P({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
}
P.create = (a) => new P({
  checks: [],
  typeName: v.ZodString,
  coerce: (a == null ? void 0 : a.coerce) ?? !1,
  ...b(a)
});
function ht(a, e) {
  const t = (a.toString().split(".")[1] || "").length, r = (e.toString().split(".")[1] || "").length, n = t > r ? t : r, s = Number.parseInt(a.toFixed(n).replace(".", "")), i = Number.parseInt(e.toFixed(n).replace(".", ""));
  return s % i / 10 ** n;
}
class Y extends k {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== h.number) {
      const s = this._getOrReturnCtx(e);
      return f(s, {
        code: d.invalid_type,
        expected: h.number,
        received: s.parsedType
      }), y;
    }
    let r;
    const n = new I();
    for (const s of this._def.checks)
      s.kind === "int" ? N.isInteger(e.data) || (r = this._getOrReturnCtx(e, r), f(r, {
        code: d.invalid_type,
        expected: "integer",
        received: "float",
        message: s.message
      }), n.dirty()) : s.kind === "min" ? (s.inclusive ? e.data < s.value : e.data <= s.value) && (r = this._getOrReturnCtx(e, r), f(r, {
        code: d.too_small,
        minimum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), n.dirty()) : s.kind === "max" ? (s.inclusive ? e.data > s.value : e.data >= s.value) && (r = this._getOrReturnCtx(e, r), f(r, {
        code: d.too_big,
        maximum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), n.dirty()) : s.kind === "multipleOf" ? ht(e.data, s.value) !== 0 && (r = this._getOrReturnCtx(e, r), f(r, {
        code: d.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), n.dirty()) : s.kind === "finite" ? Number.isFinite(e.data) || (r = this._getOrReturnCtx(e, r), f(r, {
        code: d.not_finite,
        message: s.message
      }), n.dirty()) : N.assertNever(s);
    return { status: n.value, value: e.data };
  }
  gte(e, t) {
    return this.setLimit("min", e, !0, p.toString(t));
  }
  gt(e, t) {
    return this.setLimit("min", e, !1, p.toString(t));
  }
  lte(e, t) {
    return this.setLimit("max", e, !0, p.toString(t));
  }
  lt(e, t) {
    return this.setLimit("max", e, !1, p.toString(t));
  }
  setLimit(e, t, r, n) {
    return new Y({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: t,
          inclusive: r,
          message: p.toString(n)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Y({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: p.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: p.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: p.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: p.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: p.toString(e)
    });
  }
  multipleOf(e, t) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: p.toString(t)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: p.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: p.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: p.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && N.isInteger(e.value));
  }
  get isFinite() {
    let e = null, t = null;
    for (const r of this._def.checks) {
      if (r.kind === "finite" || r.kind === "int" || r.kind === "multipleOf")
        return !0;
      r.kind === "min" ? (t === null || r.value > t) && (t = r.value) : r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    }
    return Number.isFinite(t) && Number.isFinite(e);
  }
}
Y.create = (a) => new Y({
  checks: [],
  typeName: v.ZodNumber,
  coerce: (a == null ? void 0 : a.coerce) || !1,
  ...b(a)
});
class te extends k {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== h.bigint)
      return this._getInvalidInput(e);
    let r;
    const n = new I();
    for (const s of this._def.checks)
      s.kind === "min" ? (s.inclusive ? e.data < s.value : e.data <= s.value) && (r = this._getOrReturnCtx(e, r), f(r, {
        code: d.too_small,
        type: "bigint",
        minimum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), n.dirty()) : s.kind === "max" ? (s.inclusive ? e.data > s.value : e.data >= s.value) && (r = this._getOrReturnCtx(e, r), f(r, {
        code: d.too_big,
        type: "bigint",
        maximum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), n.dirty()) : s.kind === "multipleOf" ? e.data % s.value !== BigInt(0) && (r = this._getOrReturnCtx(e, r), f(r, {
        code: d.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), n.dirty()) : N.assertNever(s);
    return { status: n.value, value: e.data };
  }
  _getInvalidInput(e) {
    const t = this._getOrReturnCtx(e);
    return f(t, {
      code: d.invalid_type,
      expected: h.bigint,
      received: t.parsedType
    }), y;
  }
  gte(e, t) {
    return this.setLimit("min", e, !0, p.toString(t));
  }
  gt(e, t) {
    return this.setLimit("min", e, !1, p.toString(t));
  }
  lte(e, t) {
    return this.setLimit("max", e, !0, p.toString(t));
  }
  lt(e, t) {
    return this.setLimit("max", e, !1, p.toString(t));
  }
  setLimit(e, t, r, n) {
    return new te({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: t,
          inclusive: r,
          message: p.toString(n)
        }
      ]
    });
  }
  _addCheck(e) {
    return new te({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: p.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: p.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: p.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: p.toString(e)
    });
  }
  multipleOf(e, t) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: p.toString(t)
    });
  }
  get minValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
}
te.create = (a) => new te({
  checks: [],
  typeName: v.ZodBigInt,
  coerce: (a == null ? void 0 : a.coerce) ?? !1,
  ...b(a)
});
class ce extends k {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== h.boolean) {
      const r = this._getOrReturnCtx(e);
      return f(r, {
        code: d.invalid_type,
        expected: h.boolean,
        received: r.parsedType
      }), y;
    }
    return Z(e.data);
  }
}
ce.create = (a) => new ce({
  typeName: v.ZodBoolean,
  coerce: (a == null ? void 0 : a.coerce) || !1,
  ...b(a)
});
class ne extends k {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== h.date) {
      const s = this._getOrReturnCtx(e);
      return f(s, {
        code: d.invalid_type,
        expected: h.date,
        received: s.parsedType
      }), y;
    }
    if (Number.isNaN(e.data.getTime())) {
      const s = this._getOrReturnCtx(e);
      return f(s, {
        code: d.invalid_date
      }), y;
    }
    const r = new I();
    let n;
    for (const s of this._def.checks)
      s.kind === "min" ? e.data.getTime() < s.value && (n = this._getOrReturnCtx(e, n), f(n, {
        code: d.too_small,
        message: s.message,
        inclusive: !0,
        exact: !1,
        minimum: s.value,
        type: "date"
      }), r.dirty()) : s.kind === "max" ? e.data.getTime() > s.value && (n = this._getOrReturnCtx(e, n), f(n, {
        code: d.too_big,
        message: s.message,
        inclusive: !0,
        exact: !1,
        maximum: s.value,
        type: "date"
      }), r.dirty()) : N.assertNever(s);
    return {
      status: r.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new ne({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, t) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: p.toString(t)
    });
  }
  max(e, t) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: p.toString(t)
    });
  }
  get minDate() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e != null ? new Date(e) : null;
  }
}
ne.create = (a) => new ne({
  checks: [],
  coerce: (a == null ? void 0 : a.coerce) || !1,
  typeName: v.ZodDate,
  ...b(a)
});
class ke extends k {
  _parse(e) {
    if (this._getType(e) !== h.symbol) {
      const r = this._getOrReturnCtx(e);
      return f(r, {
        code: d.invalid_type,
        expected: h.symbol,
        received: r.parsedType
      }), y;
    }
    return Z(e.data);
  }
}
ke.create = (a) => new ke({
  typeName: v.ZodSymbol,
  ...b(a)
});
class we extends k {
  _parse(e) {
    if (this._getType(e) !== h.undefined) {
      const r = this._getOrReturnCtx(e);
      return f(r, {
        code: d.invalid_type,
        expected: h.undefined,
        received: r.parsedType
      }), y;
    }
    return Z(e.data);
  }
}
we.create = (a) => new we({
  typeName: v.ZodUndefined,
  ...b(a)
});
class Ne extends k {
  _parse(e) {
    if (this._getType(e) !== h.null) {
      const r = this._getOrReturnCtx(e);
      return f(r, {
        code: d.invalid_type,
        expected: h.null,
        received: r.parsedType
      }), y;
    }
    return Z(e.data);
  }
}
Ne.create = (a) => new Ne({
  typeName: v.ZodNull,
  ...b(a)
});
class Ce extends k {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return Z(e.data);
  }
}
Ce.create = (a) => new Ce({
  typeName: v.ZodAny,
  ...b(a)
});
class Se extends k {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return Z(e.data);
  }
}
Se.create = (a) => new Se({
  typeName: v.ZodUnknown,
  ...b(a)
});
class W extends k {
  _parse(e) {
    const t = this._getOrReturnCtx(e);
    return f(t, {
      code: d.invalid_type,
      expected: h.never,
      received: t.parsedType
    }), y;
  }
}
W.create = (a) => new W({
  typeName: v.ZodNever,
  ...b(a)
});
class Te extends k {
  _parse(e) {
    if (this._getType(e) !== h.undefined) {
      const r = this._getOrReturnCtx(e);
      return f(r, {
        code: d.invalid_type,
        expected: h.void,
        received: r.parsedType
      }), y;
    }
    return Z(e.data);
  }
}
Te.create = (a) => new Te({
  typeName: v.ZodVoid,
  ...b(a)
});
class j extends k {
  _parse(e) {
    const { ctx: t, status: r } = this._processInputParams(e), n = this._def;
    if (t.parsedType !== h.array)
      return f(t, {
        code: d.invalid_type,
        expected: h.array,
        received: t.parsedType
      }), y;
    if (n.exactLength !== null) {
      const i = t.data.length > n.exactLength.value, o = t.data.length < n.exactLength.value;
      (i || o) && (f(t, {
        code: i ? d.too_big : d.too_small,
        minimum: o ? n.exactLength.value : void 0,
        maximum: i ? n.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: n.exactLength.message
      }), r.dirty());
    }
    if (n.minLength !== null && t.data.length < n.minLength.value && (f(t, {
      code: d.too_small,
      minimum: n.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: n.minLength.message
    }), r.dirty()), n.maxLength !== null && t.data.length > n.maxLength.value && (f(t, {
      code: d.too_big,
      maximum: n.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: n.maxLength.message
    }), r.dirty()), t.common.async)
      return Promise.all([...t.data].map((i, o) => n.type._parseAsync(new B(t, i, t.path, o)))).then((i) => I.mergeArray(r, i));
    const s = [...t.data].map((i, o) => n.type._parseSync(new B(t, i, t.path, o)));
    return I.mergeArray(r, s);
  }
  get element() {
    return this._def.type;
  }
  min(e, t) {
    return new j({
      ...this._def,
      minLength: { value: e, message: p.toString(t) }
    });
  }
  max(e, t) {
    return new j({
      ...this._def,
      maxLength: { value: e, message: p.toString(t) }
    });
  }
  length(e, t) {
    return new j({
      ...this._def,
      exactLength: { value: e, message: p.toString(t) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
j.create = (a, e) => new j({
  type: a,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: v.ZodArray,
  ...b(e)
});
function G(a) {
  if (a instanceof S) {
    const e = {};
    for (const t in a.shape) {
      const r = a.shape[t];
      e[t] = M.create(G(r));
    }
    return new S({
      ...a._def,
      shape: () => e
    });
  } else return a instanceof j ? new j({
    ...a._def,
    type: G(a.element)
  }) : a instanceof M ? M.create(G(a.unwrap())) : a instanceof X ? X.create(G(a.unwrap())) : a instanceof q ? q.create(a.items.map((e) => G(e))) : a;
}
class S extends k {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), t = N.objectKeys(e);
    return this._cached = { shape: e, keys: t }, this._cached;
  }
  _parse(e) {
    if (this._getType(e) !== h.object) {
      const m = this._getOrReturnCtx(e);
      return f(m, {
        code: d.invalid_type,
        expected: h.object,
        received: m.parsedType
      }), y;
    }
    const { status: r, ctx: n } = this._processInputParams(e), { shape: s, keys: i } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof W && this._def.unknownKeys === "strip"))
      for (const m in n.data)
        i.includes(m) || o.push(m);
    const u = [];
    for (const m of i) {
      const g = s[m], A = n.data[m];
      u.push({
        key: { status: "valid", value: m },
        value: g._parse(new B(n, A, n.path, m)),
        alwaysSet: m in n.data
      });
    }
    if (this._def.catchall instanceof W) {
      const m = this._def.unknownKeys;
      if (m === "passthrough")
        for (const g of o)
          u.push({
            key: { status: "valid", value: g },
            value: { status: "valid", value: n.data[g] }
          });
      else if (m === "strict")
        o.length > 0 && (f(n, {
          code: d.unrecognized_keys,
          keys: o
        }), r.dirty());
      else if (m !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const m = this._def.catchall;
      for (const g of o) {
        const A = n.data[g];
        u.push({
          key: { status: "valid", value: g },
          value: m._parse(
            new B(n, A, n.path, g)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: g in n.data
        });
      }
    }
    return n.common.async ? Promise.resolve().then(async () => {
      const m = [];
      for (const g of u) {
        const A = await g.key, T = await g.value;
        m.push({
          key: A,
          value: T,
          alwaysSet: g.alwaysSet
        });
      }
      return m;
    }).then((m) => I.mergeObjectSync(r, m)) : I.mergeObjectSync(r, u);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return p.errToObj, new S({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (t, r) => {
          var s, i;
          const n = ((i = (s = this._def).errorMap) == null ? void 0 : i.call(s, t, r).message) ?? r.defaultError;
          return t.code === "unrecognized_keys" ? {
            message: p.errToObj(e).message ?? n
          } : {
            message: n
          };
        }
      } : {}
    });
  }
  strip() {
    return new S({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new S({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new S({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new S({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: v.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, t) {
    return this.augment({ [e]: t });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new S({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const t = {};
    for (const r of N.objectKeys(e))
      e[r] && this.shape[r] && (t[r] = this.shape[r]);
    return new S({
      ...this._def,
      shape: () => t
    });
  }
  omit(e) {
    const t = {};
    for (const r of N.objectKeys(this.shape))
      e[r] || (t[r] = this.shape[r]);
    return new S({
      ...this._def,
      shape: () => t
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return G(this);
  }
  partial(e) {
    const t = {};
    for (const r of N.objectKeys(this.shape)) {
      const n = this.shape[r];
      e && !e[r] ? t[r] = n : t[r] = n.optional();
    }
    return new S({
      ...this._def,
      shape: () => t
    });
  }
  required(e) {
    const t = {};
    for (const r of N.objectKeys(this.shape))
      if (e && !e[r])
        t[r] = this.shape[r];
      else {
        let s = this.shape[r];
        for (; s instanceof M; )
          s = s._def.innerType;
        t[r] = s;
      }
    return new S({
      ...this._def,
      shape: () => t
    });
  }
  keyof() {
    return Fe(N.objectKeys(this.shape));
  }
}
S.create = (a, e) => new S({
  shape: () => a,
  unknownKeys: "strip",
  catchall: W.create(),
  typeName: v.ZodObject,
  ...b(e)
});
S.strictCreate = (a, e) => new S({
  shape: () => a,
  unknownKeys: "strict",
  catchall: W.create(),
  typeName: v.ZodObject,
  ...b(e)
});
S.lazycreate = (a, e) => new S({
  shape: a,
  unknownKeys: "strip",
  catchall: W.create(),
  typeName: v.ZodObject,
  ...b(e)
});
class se extends k {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), r = this._def.options;
    function n(s) {
      for (const o of s)
        if (o.result.status === "valid")
          return o.result;
      for (const o of s)
        if (o.result.status === "dirty")
          return t.common.issues.push(...o.ctx.common.issues), o.result;
      const i = s.map((o) => new V(o.ctx.common.issues));
      return f(t, {
        code: d.invalid_union,
        unionErrors: i
      }), y;
    }
    if (t.common.async)
      return Promise.all(r.map(async (s) => {
        const i = {
          ...t,
          common: {
            ...t.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await s._parseAsync({
            data: t.data,
            path: t.path,
            parent: i
          }),
          ctx: i
        };
      })).then(n);
    {
      let s;
      const i = [];
      for (const u of r) {
        const m = {
          ...t,
          common: {
            ...t.common,
            issues: []
          },
          parent: null
        }, g = u._parseSync({
          data: t.data,
          path: t.path,
          parent: m
        });
        if (g.status === "valid")
          return g;
        g.status === "dirty" && !s && (s = { result: g, ctx: m }), m.common.issues.length && i.push(m.common.issues);
      }
      if (s)
        return t.common.issues.push(...s.ctx.common.issues), s.result;
      const o = i.map((u) => new V(u));
      return f(t, {
        code: d.invalid_union,
        unionErrors: o
      }), y;
    }
  }
  get options() {
    return this._def.options;
  }
}
se.create = (a, e) => new se({
  options: a,
  typeName: v.ZodUnion,
  ...b(e)
});
function ue(a, e) {
  const t = L(a), r = L(e);
  if (a === e)
    return { valid: !0, data: a };
  if (t === h.object && r === h.object) {
    const n = N.objectKeys(e), s = N.objectKeys(a).filter((o) => n.indexOf(o) !== -1), i = { ...a, ...e };
    for (const o of s) {
      const u = ue(a[o], e[o]);
      if (!u.valid)
        return { valid: !1 };
      i[o] = u.data;
    }
    return { valid: !0, data: i };
  } else if (t === h.array && r === h.array) {
    if (a.length !== e.length)
      return { valid: !1 };
    const n = [];
    for (let s = 0; s < a.length; s++) {
      const i = a[s], o = e[s], u = ue(i, o);
      if (!u.valid)
        return { valid: !1 };
      n.push(u.data);
    }
    return { valid: !0, data: n };
  } else return t === h.date && r === h.date && +a == +e ? { valid: !0, data: a } : { valid: !1 };
}
class ie extends k {
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e), n = (s, i) => {
      if (xe(s) || xe(i))
        return y;
      const o = ue(s.value, i.value);
      return o.valid ? ((be(s) || be(i)) && t.dirty(), { status: t.value, value: o.data }) : (f(r, {
        code: d.invalid_intersection_types
      }), y);
    };
    return r.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      }),
      this._def.right._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      })
    ]).then(([s, i]) => n(s, i)) : n(this._def.left._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }), this._def.right._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }));
  }
}
ie.create = (a, e, t) => new ie({
  left: a,
  right: e,
  typeName: v.ZodIntersection,
  ...b(t)
});
class q extends k {
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== h.array)
      return f(r, {
        code: d.invalid_type,
        expected: h.array,
        received: r.parsedType
      }), y;
    if (r.data.length < this._def.items.length)
      return f(r, {
        code: d.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), y;
    !this._def.rest && r.data.length > this._def.items.length && (f(r, {
      code: d.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), t.dirty());
    const s = [...r.data].map((i, o) => {
      const u = this._def.items[o] || this._def.rest;
      return u ? u._parse(new B(r, i, r.path, o)) : null;
    }).filter((i) => !!i);
    return r.common.async ? Promise.all(s).then((i) => I.mergeArray(t, i)) : I.mergeArray(t, s);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new q({
      ...this._def,
      rest: e
    });
  }
}
q.create = (a, e) => {
  if (!Array.isArray(a))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new q({
    items: a,
    typeName: v.ZodTuple,
    rest: null,
    ...b(e)
  });
};
class Ae extends k {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== h.map)
      return f(r, {
        code: d.invalid_type,
        expected: h.map,
        received: r.parsedType
      }), y;
    const n = this._def.keyType, s = this._def.valueType, i = [...r.data.entries()].map(([o, u], m) => ({
      key: n._parse(new B(r, o, r.path, [m, "key"])),
      value: s._parse(new B(r, u, r.path, [m, "value"]))
    }));
    if (r.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const u of i) {
          const m = await u.key, g = await u.value;
          if (m.status === "aborted" || g.status === "aborted")
            return y;
          (m.status === "dirty" || g.status === "dirty") && t.dirty(), o.set(m.value, g.value);
        }
        return { status: t.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const u of i) {
        const m = u.key, g = u.value;
        if (m.status === "aborted" || g.status === "aborted")
          return y;
        (m.status === "dirty" || g.status === "dirty") && t.dirty(), o.set(m.value, g.value);
      }
      return { status: t.value, value: o };
    }
  }
}
Ae.create = (a, e, t) => new Ae({
  valueType: e,
  keyType: a,
  typeName: v.ZodMap,
  ...b(t)
});
class ae extends k {
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== h.set)
      return f(r, {
        code: d.invalid_type,
        expected: h.set,
        received: r.parsedType
      }), y;
    const n = this._def;
    n.minSize !== null && r.data.size < n.minSize.value && (f(r, {
      code: d.too_small,
      minimum: n.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: n.minSize.message
    }), t.dirty()), n.maxSize !== null && r.data.size > n.maxSize.value && (f(r, {
      code: d.too_big,
      maximum: n.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: n.maxSize.message
    }), t.dirty());
    const s = this._def.valueType;
    function i(u) {
      const m = /* @__PURE__ */ new Set();
      for (const g of u) {
        if (g.status === "aborted")
          return y;
        g.status === "dirty" && t.dirty(), m.add(g.value);
      }
      return { status: t.value, value: m };
    }
    const o = [...r.data.values()].map((u, m) => s._parse(new B(r, u, r.path, m)));
    return r.common.async ? Promise.all(o).then((u) => i(u)) : i(o);
  }
  min(e, t) {
    return new ae({
      ...this._def,
      minSize: { value: e, message: p.toString(t) }
    });
  }
  max(e, t) {
    return new ae({
      ...this._def,
      maxSize: { value: e, message: p.toString(t) }
    });
  }
  size(e, t) {
    return this.min(e, t).max(e, t);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
ae.create = (a, e) => new ae({
  valueType: a,
  minSize: null,
  maxSize: null,
  typeName: v.ZodSet,
  ...b(e)
});
class Oe extends k {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    return this._def.getter()._parse({ data: t.data, path: t.path, parent: t });
  }
}
Oe.create = (a, e) => new Oe({
  getter: a,
  typeName: v.ZodLazy,
  ...b(e)
});
class Re extends k {
  _parse(e) {
    if (e.data !== this._def.value) {
      const t = this._getOrReturnCtx(e);
      return f(t, {
        received: t.data,
        code: d.invalid_literal,
        expected: this._def.value
      }), y;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
Re.create = (a, e) => new Re({
  value: a,
  typeName: v.ZodLiteral,
  ...b(e)
});
function Fe(a, e) {
  return new J({
    values: a,
    typeName: v.ZodEnum,
    ...b(e)
  });
}
class J extends k {
  _parse(e) {
    if (typeof e.data != "string") {
      const t = this._getOrReturnCtx(e), r = this._def.values;
      return f(t, {
        expected: N.joinValues(r),
        received: t.parsedType,
        code: d.invalid_type
      }), y;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(e.data)) {
      const t = this._getOrReturnCtx(e), r = this._def.values;
      return f(t, {
        received: t.data,
        code: d.invalid_enum_value,
        options: r
      }), y;
    }
    return Z(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  get Values() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  get Enum() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  extract(e, t = this._def) {
    return J.create(e, {
      ...this._def,
      ...t
    });
  }
  exclude(e, t = this._def) {
    return J.create(this.options.filter((r) => !e.includes(r)), {
      ...this._def,
      ...t
    });
  }
}
J.create = Fe;
class Ie extends k {
  _parse(e) {
    const t = N.getValidEnumValues(this._def.values), r = this._getOrReturnCtx(e);
    if (r.parsedType !== h.string && r.parsedType !== h.number) {
      const n = N.objectValues(t);
      return f(r, {
        expected: N.joinValues(n),
        received: r.parsedType,
        code: d.invalid_type
      }), y;
    }
    if (this._cache || (this._cache = new Set(N.getValidEnumValues(this._def.values))), !this._cache.has(e.data)) {
      const n = N.objectValues(t);
      return f(r, {
        received: r.data,
        code: d.invalid_enum_value,
        options: n
      }), y;
    }
    return Z(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
Ie.create = (a, e) => new Ie({
  values: a,
  typeName: v.ZodNativeEnum,
  ...b(e)
});
class oe extends k {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    if (t.parsedType !== h.promise && t.common.async === !1)
      return f(t, {
        code: d.invalid_type,
        expected: h.promise,
        received: t.parsedType
      }), y;
    const r = t.parsedType === h.promise ? t.data : Promise.resolve(t.data);
    return Z(r.then((n) => this._def.type.parseAsync(n, {
      path: t.path,
      errorMap: t.common.contextualErrorMap
    })));
  }
}
oe.create = (a, e) => new oe({
  type: a,
  typeName: v.ZodPromise,
  ...b(e)
});
class Q extends k {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === v.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e), n = this._def.effect || null, s = {
      addIssue: (i) => {
        f(r, i), i.fatal ? t.abort() : t.dirty();
      },
      get path() {
        return r.path;
      }
    };
    if (s.addIssue = s.addIssue.bind(s), n.type === "preprocess") {
      const i = n.transform(r.data, s);
      if (r.common.async)
        return Promise.resolve(i).then(async (o) => {
          if (t.value === "aborted")
            return y;
          const u = await this._def.schema._parseAsync({
            data: o,
            path: r.path,
            parent: r
          });
          return u.status === "aborted" ? y : u.status === "dirty" || t.value === "dirty" ? ee(u.value) : u;
        });
      {
        if (t.value === "aborted")
          return y;
        const o = this._def.schema._parseSync({
          data: i,
          path: r.path,
          parent: r
        });
        return o.status === "aborted" ? y : o.status === "dirty" || t.value === "dirty" ? ee(o.value) : o;
      }
    }
    if (n.type === "refinement") {
      const i = (o) => {
        const u = n.refinement(o, s);
        if (r.common.async)
          return Promise.resolve(u);
        if (u instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (r.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return o.status === "aborted" ? y : (o.status === "dirty" && t.dirty(), i(o.value), { status: t.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((o) => o.status === "aborted" ? y : (o.status === "dirty" && t.dirty(), i(o.value).then(() => ({ status: t.value, value: o.value }))));
    }
    if (n.type === "transform")
      if (r.common.async === !1) {
        const i = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        if (!H(i))
          return y;
        const o = n.transform(i.value, s);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: t.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((i) => H(i) ? Promise.resolve(n.transform(i.value, s)).then((o) => ({
          status: t.value,
          value: o
        })) : y);
    N.assertNever(n);
  }
}
Q.create = (a, e, t) => new Q({
  schema: a,
  typeName: v.ZodEffects,
  effect: e,
  ...b(t)
});
Q.createWithPreprocess = (a, e, t) => new Q({
  schema: e,
  effect: { type: "preprocess", transform: a },
  typeName: v.ZodEffects,
  ...b(t)
});
class M extends k {
  _parse(e) {
    return this._getType(e) === h.undefined ? Z(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
M.create = (a, e) => new M({
  innerType: a,
  typeName: v.ZodOptional,
  ...b(e)
});
class X extends k {
  _parse(e) {
    return this._getType(e) === h.null ? Z(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
X.create = (a, e) => new X({
  innerType: a,
  typeName: v.ZodNullable,
  ...b(e)
});
class me extends k {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    let r = t.data;
    return t.parsedType === h.undefined && (r = this._def.defaultValue()), this._def.innerType._parse({
      data: r,
      path: t.path,
      parent: t
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
me.create = (a, e) => new me({
  innerType: a,
  typeName: v.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...b(e)
});
class fe extends k {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), r = {
      ...t,
      common: {
        ...t.common,
        issues: []
      }
    }, n = this._def.innerType._parse({
      data: r.data,
      path: r.path,
      parent: {
        ...r
      }
    });
    return re(n) ? n.then((s) => ({
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new V(r.common.issues);
        },
        input: r.data
      })
    })) : {
      status: "valid",
      value: n.status === "valid" ? n.value : this._def.catchValue({
        get error() {
          return new V(r.common.issues);
        },
        input: r.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
fe.create = (a, e) => new fe({
  innerType: a,
  typeName: v.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...b(e)
});
class Ze extends k {
  _parse(e) {
    if (this._getType(e) !== h.nan) {
      const r = this._getOrReturnCtx(e);
      return f(r, {
        code: d.invalid_type,
        expected: h.nan,
        received: r.parsedType
      }), y;
    }
    return { status: "valid", value: e.data };
  }
}
Ze.create = (a) => new Ze({
  typeName: v.ZodNaN,
  ...b(a)
});
class pt extends k {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), r = t.data;
    return this._def.type._parse({
      data: r,
      path: t.path,
      parent: t
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class pe extends k {
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e);
    if (r.common.async)
      return (async () => {
        const s = await this._def.in._parseAsync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return s.status === "aborted" ? y : s.status === "dirty" ? (t.dirty(), ee(s.value)) : this._def.out._parseAsync({
          data: s.value,
          path: r.path,
          parent: r
        });
      })();
    {
      const n = this._def.in._parseSync({
        data: r.data,
        path: r.path,
        parent: r
      });
      return n.status === "aborted" ? y : n.status === "dirty" ? (t.dirty(), {
        status: "dirty",
        value: n.value
      }) : this._def.out._parseSync({
        data: n.value,
        path: r.path,
        parent: r
      });
    }
  }
  static create(e, t) {
    return new pe({
      in: e,
      out: t,
      typeName: v.ZodPipeline
    });
  }
}
class he extends k {
  _parse(e) {
    const t = this._def.innerType._parse(e), r = (n) => (H(n) && (n.value = Object.freeze(n.value)), n);
    return re(t) ? t.then((n) => r(n)) : r(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
he.create = (a, e) => new he({
  innerType: a,
  typeName: v.ZodReadonly,
  ...b(e)
});
var v;
(function(a) {
  a.ZodString = "ZodString", a.ZodNumber = "ZodNumber", a.ZodNaN = "ZodNaN", a.ZodBigInt = "ZodBigInt", a.ZodBoolean = "ZodBoolean", a.ZodDate = "ZodDate", a.ZodSymbol = "ZodSymbol", a.ZodUndefined = "ZodUndefined", a.ZodNull = "ZodNull", a.ZodAny = "ZodAny", a.ZodUnknown = "ZodUnknown", a.ZodNever = "ZodNever", a.ZodVoid = "ZodVoid", a.ZodArray = "ZodArray", a.ZodObject = "ZodObject", a.ZodUnion = "ZodUnion", a.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", a.ZodIntersection = "ZodIntersection", a.ZodTuple = "ZodTuple", a.ZodRecord = "ZodRecord", a.ZodMap = "ZodMap", a.ZodSet = "ZodSet", a.ZodFunction = "ZodFunction", a.ZodLazy = "ZodLazy", a.ZodLiteral = "ZodLiteral", a.ZodEnum = "ZodEnum", a.ZodEffects = "ZodEffects", a.ZodNativeEnum = "ZodNativeEnum", a.ZodOptional = "ZodOptional", a.ZodNullable = "ZodNullable", a.ZodDefault = "ZodDefault", a.ZodCatch = "ZodCatch", a.ZodPromise = "ZodPromise", a.ZodBranded = "ZodBranded", a.ZodPipeline = "ZodPipeline", a.ZodReadonly = "ZodReadonly";
})(v || (v = {}));
const c = P.create, je = Y.create, D = ce.create;
W.create;
const $ = j.create, C = S.create;
se.create;
ie.create;
q.create;
const _ = J.create;
oe.create;
M.create;
X.create;
function ze(a) {
  var e, t, r = "";
  if (typeof a == "string" || typeof a == "number") r += a;
  else if (typeof a == "object") if (Array.isArray(a)) {
    var n = a.length;
    for (e = 0; e < n; e++) a[e] && (t = ze(a[e])) && (r && (r += " "), r += t);
  } else for (t in a) a[t] && (r && (r += " "), r += t);
  return r;
}
function w() {
  for (var a, e, t = 0, r = "", n = arguments.length; t < n; t++) (a = arguments[t]) && (e = ze(a)) && (r && (r += " "), r += e);
  return r;
}
const gt = C({
  background: _(["transparent", "surface", "brand", "contrast"]).default("transparent"),
  padding: _(["none", "sm", "md", "lg", "xl"]).default("md"),
  maxWidth: _(["none", "prose", "xl", "2xl", "7xl"]).default("none"),
  /** Optional full-bleed background image (URL). Overrides the color background
   *  and renders an optional dark scrim beneath the content for legibility. */
  backgroundImage: c().url().optional(),
  backgroundPosition: _(["center", "top", "bottom"]).default("center"),
  backgroundOverlay: _(["none", "light", "medium", "strong"]).default("none"),
  className: c().optional()
}), yt = {
  transparent: {},
  surface: {
    // Honors design surface tokens: gradient > glass translucent fill > solid.
    // When no design tokens are set, falls back to the solid surface color.
    background: "var(--dl-surface-gradient, var(--dl-surface-bg, var(--dl-surface, #fafafa)))",
    color: "var(--dl-on-surface, #0a0a0a)",
    backdropFilter: "blur(var(--dl-surface-blur, 0px))",
    WebkitBackdropFilter: "blur(var(--dl-surface-blur, 0px))"
  },
  brand: { backgroundColor: "var(--dl-brand, #2563eb)", color: "var(--dl-on-brand, #ffffff)" },
  contrast: { backgroundColor: "var(--dl-contrast, #0a0a0a)", color: "var(--dl-on-contrast, #fafafa)" }
}, vt = {
  none: "py-0",
  sm: "py-6",
  md: "py-12",
  lg: "py-20",
  xl: "py-28"
}, xt = {
  none: "",
  prose: "max-w-prose mx-auto px-4",
  xl: "max-w-xl mx-auto px-4",
  "2xl": "max-w-2xl mx-auto px-4",
  "7xl": "max-w-7xl mx-auto px-4"
}, bt = {
  none: 0,
  light: 0.25,
  medium: 0.45,
  strong: 0.65
};
function _t(a) {
  const {
    background: e = "transparent",
    padding: t = "md",
    maxWidth: r = "none",
    backgroundImage: n,
    backgroundPosition: s = "center",
    backgroundOverlay: i = "none",
    className: o,
    children: u
  } = a, m = !!n, g = bt[i] ?? 0, A = m ? {
    position: "relative",
    backgroundImage: `url("${n}")`,
    backgroundSize: "cover",
    backgroundPosition: s,
    backgroundRepeat: "no-repeat"
  } : yt[e] ?? {}, T = r === "none" ? u : /* @__PURE__ */ l("div", { className: xt[r], children: u });
  return /* @__PURE__ */ x(
    "section",
    {
      "data-node-id": a["data-node-id"],
      style: A,
      className: w("w-full", vt[t], o),
      children: [
        m && g > 0 ? /* @__PURE__ */ l(
          "span",
          {
            "aria-hidden": !0,
            style: { position: "absolute", inset: 0, backgroundColor: `rgba(0,0,0,${g})`, pointerEvents: "none" }
          }
        ) : null,
        m ? /* @__PURE__ */ l("div", { style: { position: "relative", zIndex: 1 }, children: T }) : T
      ]
    }
  );
}
const kt = C({
  maxWidth: _(["md", "lg", "xl", "2xl", "7xl"]).default("7xl"),
  align: _(["start", "center", "end"]).default("start"),
  gap: _(["0", "2", "4", "6", "8", "12"]).default("4"),
  className: c().optional()
}), wt = {
  md: "max-w-md",
  lg: "max-w-lg",
  xl: "max-w-xl",
  "2xl": "max-w-2xl",
  "7xl": "max-w-7xl"
}, Nt = {
  start: "items-start",
  center: "items-center",
  end: "items-end"
};
function Ct(a) {
  const { maxWidth: e = "7xl", align: t = "start", gap: r = "4", className: n, children: s } = a;
  return /* @__PURE__ */ l(
    "div",
    {
      "data-node-id": a["data-node-id"],
      className: w("mx-auto px-4 flex flex-col", wt[e], Nt[t], `gap-${r}`, n),
      style: {
        // Design-token aware "card" surface. Every value falls back to a
        // no-op (transparent / 0 / none), so an unthemed Container looks
        // exactly as before; a design theme can turn it into a glass,
        // gradient, bordered, or elevated card.
        background: "var(--dl-surface-gradient, var(--dl-surface-bg, transparent))",
        backdropFilter: "blur(var(--dl-surface-blur, 0px))",
        WebkitBackdropFilter: "blur(var(--dl-surface-blur, 0px))",
        borderRadius: "var(--dl-radius, 0px)",
        borderWidth: "var(--dl-border-width, 0px)",
        borderStyle: "solid",
        borderColor: "var(--dl-border-color, transparent)",
        boxShadow: "var(--dl-shadow, none)"
      },
      children: s
    }
  );
}
const St = C({
  // Numeric tokens are expressed as string enums (project convention — see
  // Container.gap). `@md:grid-cols-{N}` classes are mapped statically below so
  // Tailwind's JIT picks them up; do not build the class name dynamically.
  columns: _(["2", "3", "4", "6"]).default("3"),
  gap: _(["none", "sm", "md", "lg"]).default("md"),
  align: _(["start", "center", "stretch"]).default("stretch"),
  className: c().optional()
}), Tt = {
  2: "@md:grid-cols-2",
  3: "@md:grid-cols-3",
  4: "@md:grid-cols-4",
  6: "@md:grid-cols-6"
}, At = {
  none: "gap-0",
  sm: "gap-4",
  md: "gap-6",
  lg: "gap-10"
}, Ot = {
  start: "items-start",
  center: "items-center",
  stretch: "items-stretch"
};
function Rt(a) {
  const { columns: e = "3", gap: t = "md", align: r = "stretch", className: n, children: s } = a;
  return (
    // The `@container` MUST be an ANCESTOR of the grid: container-query variants
    // (`@md:`) resolve against the nearest ancestor container, NOT the element
    // that declares `@container`. With both on one element the grid never
    // expanded past one column. Wrap in a container, put the grid on the child —
    // the Stats/Testimonials pattern.
    /* @__PURE__ */ l("div", { "data-node-id": a["data-node-id"], className: "@container", children: /* @__PURE__ */ l(
      "div",
      {
        className: w(
          "grid grid-cols-1",
          Tt[e],
          At[t],
          Ot[r],
          n
        ),
        style: {
          // Design-token aware surface, consistent with Container: every value
          // falls back to a no-op so an unthemed Grid is invisible chrome; a
          // theme can turn the grid wrapper into a glass / bordered / elevated
          // card surface.
          background: "var(--dl-surface-gradient, var(--dl-surface-bg, transparent))",
          backdropFilter: "blur(var(--dl-surface-blur, 0px))",
          WebkitBackdropFilter: "blur(var(--dl-surface-blur, 0px))",
          borderRadius: "var(--dl-radius, 0px)",
          borderWidth: "var(--dl-border-width, 0px)",
          borderStyle: "solid",
          borderColor: "var(--dl-border-color, transparent)",
          boxShadow: "var(--dl-shadow, none)"
        },
        children: s
      }
    ) })
  );
}
const It = C({
  // Numeric tokens as string enums (project convention — see Container.gap).
  count: _(["2", "3", "4"]).default("2"),
  gap: _(["none", "sm", "md", "lg"]).default("md"),
  className: c().optional()
}), Zt = {
  2: "@md:grid-cols-2",
  3: "@md:grid-cols-3",
  4: "@md:grid-cols-4"
}, jt = {
  none: "gap-0",
  sm: "gap-4",
  md: "gap-6",
  lg: "gap-10"
};
function $t(a) {
  const { count: e = "2", gap: t = "md", className: r, children: n } = a;
  return (
    // `@container` must wrap the grid, not share its element — `@md:` queries the
    // nearest ancestor container (see Grid.tsx for the full note).
    /* @__PURE__ */ l("div", { "data-node-id": a["data-node-id"], className: "@container", children: /* @__PURE__ */ l(
      "div",
      {
        className: w("grid grid-cols-1", Zt[e], jt[t], r),
        style: {
          // Lightweight token awareness: honor the theme corner radius (no-op
          // when unset). Columns deliberately omits the full card surface that
          // Grid carries — it is the "just lay them out" primitive.
          borderRadius: "var(--dl-radius, 0px)"
        },
        children: n
      }
    ) })
  );
}
const Et = C({
  eyebrow: c().optional(),
  headline: c().min(1),
  subline: c().optional(),
  imageSrc: c().url().optional(),
  imageAlt: c().optional(),
  ctaLabel: c().optional(),
  ctaHref: c().optional(),
  /** Small trust note next to the CTA (e.g. "No paperwork", "Free for 30 days").
   *  Mono-styled with a green dot. Hidden when empty. */
  ctaTrustNote: c().optional(),
  layout: _(["text-left", "text-center", "split"]).default("text-left"),
  /** Optional full-bleed background image (URL) behind the hero, with an
   *  optional dark scrim for legibility. Distinct from imageSrc (the side image). */
  backgroundImage: c().url().optional(),
  backgroundPosition: _(["center", "top", "bottom"]).default("center"),
  backgroundOverlay: _(["none", "light", "medium", "strong"]).default("none"),
  className: c().optional()
}), Ft = {
  none: 0,
  light: 0.25,
  medium: 0.45,
  strong: 0.65
};
function zt(a) {
  const { eyebrow: e, headline: t, subline: r, imageSrc: n, imageAlt: s, ctaLabel: i, ctaHref: o, ctaTrustNote: u, layout: m = "text-left", backgroundImage: g, backgroundPosition: A = "center", backgroundOverlay: T = "none", className: O } = a, R = m === "split", E = m === "text-center", U = !!g, K = Ft[T] ?? 0;
  return /* @__PURE__ */ x(
    "div",
    {
      "data-node-id": a["data-node-id"],
      style: U ? {
        backgroundImage: `url("${g}")`,
        backgroundSize: "cover",
        backgroundPosition: A,
        backgroundRepeat: "no-repeat"
      } : void 0,
      className: w(
        "@container relative",
        "px-5 py-14 @md:py-24 @lg:py-32 @xl:py-40",
        E && "text-center",
        R && "grid @md:grid-cols-[1.1fr_1fr] gap-10 @md:gap-16 items-center",
        O
      ),
      children: [
        U && K > 0 ? /* @__PURE__ */ l(
          "span",
          {
            "aria-hidden": !0,
            className: "absolute inset-0 z-0",
            style: { backgroundColor: `rgba(0,0,0,${K})`, pointerEvents: "none" }
          }
        ) : null,
        /* @__PURE__ */ x(
          "div",
          {
            className: w(
              "relative z-10 max-w-3xl",
              E && "mx-auto",
              R && "order-2 @md:order-1"
            ),
            children: [
              e ? /* @__PURE__ */ x(
                "div",
                {
                  className: w(
                    "dl-anim-rise inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.18em] mb-5 @md:mb-7",
                    E && "justify-center"
                  ),
                  style: {
                    fontFamily: "var(--dl-font-mono, ui-monospace, monospace)",
                    color: "var(--dl-brand, #2563eb)",
                    animationDelay: "40ms"
                  },
                  children: [
                    /* @__PURE__ */ l(
                      "span",
                      {
                        "aria-hidden": !0,
                        className: "inline-block h-px w-6",
                        style: { backgroundColor: "currentColor" }
                      }
                    ),
                    e
                  ]
                }
              ) : null,
              /* @__PURE__ */ l(
                "h1",
                {
                  "data-dl-edit": "headline",
                  className: w(
                    "dl-anim-rise font-display leading-[1.05] tracking-[-0.025em]",
                    "text-[calc(2.5rem*var(--dl-font-scale,1))] @md:text-[calc(4.25rem*var(--dl-font-scale,1))] @lg:text-[calc(5.25rem*var(--dl-font-scale,1))] @xl:text-[calc(6rem*var(--dl-font-scale,1))]",
                    "[font-variation-settings:'opsz'_144]"
                  ),
                  style: {
                    fontFamily: "var(--dl-font-display, Georgia, serif)",
                    fontWeight: 600,
                    animationDelay: "120ms"
                  },
                  children: t
                }
              ),
              r ? /* @__PURE__ */ l(
                "p",
                {
                  "data-dl-edit": "subline",
                  className: w(
                    "dl-anim-rise mt-5 @md:mt-7 max-w-xl text-base @md:text-lg @lg:text-xl leading-relaxed opacity-75",
                    E && "mx-auto"
                  ),
                  style: { animationDelay: "220ms" },
                  children: r
                }
              ) : null,
              i && o ? /* @__PURE__ */ x(
                "div",
                {
                  className: w(
                    "dl-anim-rise mt-8 @md:mt-10 flex items-center gap-4 text-sm",
                    E && "justify-center"
                  ),
                  style: { animationDelay: "320ms" },
                  children: [
                    /* @__PURE__ */ x(
                      "a",
                      {
                        href: o,
                        className: "group relative inline-flex items-center gap-2 px-6 py-3.5 font-medium transition-transform duration-200 hover:-translate-y-0.5",
                        style: {
                          // Glass/gradient-aware via --dl-btn-* (solid-brand fallback).
                          background: "var(--dl-btn-bg, var(--dl-brand, #2563eb))",
                          color: "var(--dl-btn-fg, var(--dl-on-brand, #ffffff))",
                          border: "var(--dl-btn-border, none)",
                          backdropFilter: "blur(var(--dl-btn-blur, 0px))",
                          WebkitBackdropFilter: "blur(var(--dl-btn-blur, 0px))",
                          borderRadius: "var(--dl-radius, 9999px)",
                          boxShadow: "var(--dl-btn-shadow, var(--dl-shadow, 0 1px 0 0 color-mix(in srgb, var(--dl-on-surface, #000) 8%, transparent), 0 8px 28px -12px color-mix(in srgb, var(--dl-brand, #2563eb) 60%, transparent)))"
                        },
                        children: [
                          /* @__PURE__ */ l("span", { "data-dl-edit": "ctaLabel", children: i }),
                          /* @__PURE__ */ l("span", { "aria-hidden": !0, className: "transition-transform duration-200 group-hover:translate-x-1", children: "→" })
                        ]
                      }
                    ),
                    u ? /* @__PURE__ */ x(
                      "span",
                      {
                        className: "hidden @md:inline-flex items-center gap-1.5 opacity-60 text-xs uppercase tracking-[0.16em]",
                        style: { fontFamily: "var(--dl-font-mono, monospace)" },
                        children: [
                          /* @__PURE__ */ l("span", { className: "inline-block h-1.5 w-1.5 rounded-full", style: { backgroundColor: "var(--dl-success, #16a34a)" } }),
                          u
                        ]
                      }
                    ) : null
                  ]
                }
              ) : null
            ]
          }
        ),
        n ? /* @__PURE__ */ x(
          "figure",
          {
            className: w(
              "dl-anim-rise relative z-10",
              R ? "order-1 @md:order-2" : "mt-10 @md:mt-14"
            ),
            style: { animationDelay: "180ms" },
            children: [
              /* @__PURE__ */ l(
                "div",
                {
                  "aria-hidden": !0,
                  className: "absolute inset-0 -z-10 translate-x-3 translate-y-3 rounded-[28px]",
                  style: {
                    backgroundColor: "var(--dl-brand, #2563eb)",
                    opacity: 0.12
                  }
                }
              ),
              /* @__PURE__ */ l(
                "img",
                {
                  src: n,
                  alt: s ?? "",
                  className: "relative w-full h-auto object-cover",
                  style: {
                    borderRadius: "var(--dl-radius, 24px)",
                    boxShadow: "var(--dl-shadow, 0 1px 0 0 color-mix(in srgb, var(--dl-on-surface, #000) 8%, transparent), 0 30px 60px -30px color-mix(in srgb, var(--dl-on-surface, #000) 30%, transparent))"
                  },
                  loading: "eager",
                  decoding: "async"
                }
              )
            ]
          }
        ) : null,
        /* @__PURE__ */ l(Vt, {})
      ]
    }
  );
}
function Vt() {
  return /* @__PURE__ */ l("style", { children: `
      @keyframes dl-rise {
        from { opacity: 0; transform: translateY(14px); }
        to { opacity: 1; transform: translateY(0); }
      }
      .dl-anim-rise {
        opacity: 0;
        animation: dl-rise 0.7s cubic-bezier(0.2, 0.8, 0.2, 1) forwards;
      }
      @media (prefers-reduced-motion: reduce) {
        .dl-anim-rise { animation: none; opacity: 1; transform: none; }
      }
    ` });
}
const Lt = C({
  intensity: _(["subtle", "medium", "vivid"]).default("medium"),
  padding: _(["sm", "md", "lg", "xl"]).default("lg"),
  align: _(["start", "center"]).default("center"),
  className: c().optional()
}), Pt = {
  subtle: { a: 24, b: 20, c: 16, d: 10 },
  medium: { a: 42, b: 36, c: 28, d: 16 },
  vivid: { a: 60, b: 52, c: 42, d: 24 }
}, Mt = {
  sm: "px-5 py-10 @md:py-14",
  md: "px-5 py-14 @md:py-20",
  lg: "px-5 py-20 @md:py-28",
  xl: "px-5 py-28 @md:py-40"
};
function Bt(a) {
  const { intensity: e = "medium", padding: t = "lg", align: r = "center", className: n, children: s } = a, i = Pt[e], o = (m, g) => `color-mix(in srgb, var(${m}, #2563eb) ${g}%, transparent)`, u = [
    `radial-gradient(at 18% 26%, ${o("--dl-brand", i.a)} 0px, transparent 50%)`,
    `radial-gradient(at 82% 18%, ${o("--dl-accent", i.b)} 0px, transparent 50%)`,
    `radial-gradient(at 50% 84%, ${o("--dl-brand", i.c)} 0px, transparent 50%)`,
    `radial-gradient(at 74% 62%, ${o("--dl-contrast", i.d)} 0px, transparent 55%)`
  ].join(", ");
  return /* @__PURE__ */ l(
    "div",
    {
      "data-node-id": a["data-node-id"],
      className: w(
        "@container relative isolate w-full",
        Mt[t],
        r === "center" && "text-center",
        n
      ),
      style: {
        backgroundColor: "var(--dl-surface, #ffffff)",
        backgroundImage: u,
        color: "var(--dl-on-surface, #0a0a0a)"
      },
      children: /* @__PURE__ */ l("div", { className: w("mx-auto max-w-5xl", r === "center" && "flex flex-col items-center"), children: s })
    }
  );
}
const Wt = C({
  /** Markdown-subset body: blank-line-separated blocks; #/##/### headings; - lists. */
  content: c().min(1),
  size: _(["sm", "base", "lg", "xl"]).default("base"),
  align: _(["start", "center"]).default("start"),
  className: c().optional()
}), Dt = {
  sm: "prose-sm",
  base: "",
  lg: "prose-lg",
  xl: "prose-xl"
};
function qt(a) {
  return a.split(/\n\s*\n/).map((t) => t.trim()).filter(Boolean).map((t, r) => {
    const n = /^(#{1,3})\s+(.+)$/.exec(t);
    if (n) {
      const i = n[2].trim();
      return n[1].length === 1 ? /* @__PURE__ */ l("h1", { children: i }, r) : n[1].length === 2 ? /* @__PURE__ */ l("h2", { children: i }, r) : /* @__PURE__ */ l("h3", { children: i }, r);
    }
    const s = t.split(`
`).map((i) => i.trim());
    return s.length > 0 && s.every((i) => /^[-*]\s+/.test(i)) ? /* @__PURE__ */ l("ul", { children: s.map((i, o) => /* @__PURE__ */ l("li", { children: i.replace(/^[-*]\s+/, "") }, o)) }, r) : /* @__PURE__ */ l("p", { children: t.replace(/\n/g, " ") }, r);
  });
}
function Ut(a) {
  const { content: e, size: t = "base", align: r = "start", className: n } = a;
  return /* @__PURE__ */ l(
    "div",
    {
      "data-node-id": a["data-node-id"],
      className: w(
        "prose max-w-none px-5 py-12 @md:py-16",
        Dt[t],
        r === "center" && "mx-auto text-center",
        // Headings pick up the theme display face; everything else the body face.
        "[&_h1]:[font-family:var(--dl-font-display,Georgia,serif)]",
        "[&_h2]:[font-family:var(--dl-font-display,Georgia,serif)]",
        "[&_h3]:[font-family:var(--dl-font-display,Georgia,serif)]",
        n
      ),
      style: {
        // Map the Typography plugin's theme hooks to the page's design tokens.
        "--tw-prose-body": "var(--dl-on-surface, #374151)",
        "--tw-prose-headings": "var(--dl-on-surface, #111827)",
        "--tw-prose-bold": "var(--dl-on-surface, #111827)",
        "--tw-prose-links": "var(--dl-brand, #2563eb)",
        "--tw-prose-bullets": "var(--dl-brand, #2563eb)",
        "--tw-prose-quotes": "var(--dl-on-surface, #111827)",
        "--tw-prose-quote-borders": "var(--dl-brand, #2563eb)",
        "--tw-prose-hr": "var(--dl-border-color, #e5e7eb)",
        color: "var(--dl-on-surface, #374151)",
        fontFamily: "var(--dl-font-body, ui-sans-serif, system-ui, sans-serif)"
      },
      children: qt(e)
    }
  );
}
const Gt = C({
  content: c().min(1),
  as: _(["h2", "h3", "h4", "p", "lead"]).default("p"),
  align: _(["left", "center", "right"]).default("left"),
  tone: _(["default", "muted", "emphasis"]).default("default"),
  className: c().optional()
}), Ht = {
  h2: "text-[1.875rem] @md:text-[2.5rem] @lg:text-[3rem] leading-[1.1] tracking-[-0.02em]",
  h3: "text-[1.5rem] @md:text-[1.875rem] leading-[1.2] tracking-[-0.015em]",
  h4: "text-[1.25rem] @md:text-[1.375rem] leading-snug",
  p: "text-[15.5px] @md:text-[16px] leading-[1.65]",
  lead: "text-[19px] @md:text-[22px] leading-[1.45] tracking-[-0.005em]"
}, Yt = { left: "text-left", center: "text-center", right: "text-right" };
function Jt(a) {
  const { content: e, as: t = "p", align: r = "left", tone: n = "default", className: s } = a, i = t === "h2" || t === "h3" || t === "h4", o = t === "lead", g = {
    fontFamily: i || o ? "var(--dl-font-display, Georgia, serif)" : "var(--dl-font-body, ui-sans-serif, sans-serif)",
    fontVariationSettings: `'opsz' ${t === "h2" ? 100 : t === "h3" ? 60 : t === "h4" || o ? 36 : 14}`,
    fontWeight: i ? 600 : o ? 500 : 400
  };
  n === "emphasis" && (g.color = "var(--dl-brand, #2563eb)");
  const A = n === "muted" ? "opacity-60" : o ? "opacity-90" : "", T = w(Ht[t], Yt[r], A, s), O = a["data-node-id"];
  switch (t) {
    case "h2":
      return /* @__PURE__ */ l("h2", { "data-node-id": O, "data-dl-edit": "content", className: T, style: g, children: e });
    case "h3":
      return /* @__PURE__ */ l("h3", { "data-node-id": O, "data-dl-edit": "content", className: T, style: g, children: e });
    case "h4":
      return /* @__PURE__ */ l("h4", { "data-node-id": O, "data-dl-edit": "content", className: T, style: g, children: e });
    default:
      return /* @__PURE__ */ l("p", { "data-node-id": O, "data-dl-edit": "content", className: T, style: g, children: e });
  }
}
const Qt = C({
  src: c().url(),
  alt: c(),
  width: je().int().positive().optional(),
  height: je().int().positive().optional(),
  srcSet: c().optional(),
  sizes: c().optional(),
  loading: _(["eager", "lazy"]).default("lazy"),
  rounded: _(["none", "md", "lg", "2xl", "full"]).default("lg"),
  className: c().optional()
}), Xt = {
  none: "rounded-none",
  md: "rounded-md",
  lg: "rounded-lg",
  "2xl": "rounded-2xl",
  full: "rounded-full"
};
function Kt(a) {
  const { src: e, alt: t, width: r, height: n, srcSet: s, sizes: i, loading: o = "lazy", rounded: u = "lg", className: m } = a;
  return /* @__PURE__ */ l(
    "img",
    {
      "data-node-id": a["data-node-id"],
      src: e,
      alt: t,
      width: r,
      height: n,
      srcSet: s,
      sizes: i,
      loading: o,
      decoding: "async",
      className: w("max-w-full h-auto", Xt[u], m)
    }
  );
}
const ea = C({
  /** YouTube/Vimeo URL or id, or an .mp4 URL (per `provider`). */
  src: c().min(1),
  provider: _(["youtube", "vimeo", "mp4"]).default("youtube"),
  aspectRatio: _(["16/9", "4/3", "1/1", "21/9"]).default("16/9"),
  title: c().optional(),
  autoplay: D().default(!1),
  loop: D().default(!1),
  muted: D().default(!1),
  /** Poster image (mp4 only). */
  poster: c().url().optional(),
  className: c().optional()
});
function ta(a) {
  const e = a.match(/(?:youtu\.be\/|[?&]v=|embed\/)([\w-]{6,})/);
  return (e == null ? void 0 : e[1]) ?? a;
}
function aa(a) {
  const e = a.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  return (e == null ? void 0 : e[1]) ?? a;
}
function ra(a) {
  const {
    src: e,
    provider: t = "youtube",
    aspectRatio: r = "16/9",
    title: n,
    autoplay: s = !1,
    loop: i = !1,
    muted: o = !1,
    poster: u,
    className: m
  } = a, g = {
    aspectRatio: r,
    borderRadius: "var(--dl-radius, 16px)",
    backgroundColor: "var(--dl-contrast, #0a0a0a)"
  }, A = w("relative w-full overflow-hidden", m);
  if (t === "mp4")
    return /* @__PURE__ */ l("div", { "data-node-id": a["data-node-id"], className: A, style: g, children: /* @__PURE__ */ l(
      "video",
      {
        src: e,
        poster: u,
        controls: !0,
        autoPlay: s,
        loop: i,
        muted: o || s,
        playsInline: !0,
        className: "absolute inset-0 h-full w-full object-cover"
      }
    ) });
  const T = t === "youtube" ? ta(e) : aa(e), O = new URLSearchParams();
  s && (O.set("autoplay", "1"), O.set("muted", "1")), i && (O.set("loop", "1"), t === "youtube" && O.set("playlist", T));
  const R = O.toString(), E = t === "youtube" ? `https://www.youtube-nocookie.com/embed/${T}${R ? `?${R}` : ""}` : `https://player.vimeo.com/video/${T}${R ? `?${R}` : ""}`;
  return /* @__PURE__ */ l("div", { "data-node-id": a["data-node-id"], className: A, style: g, children: /* @__PURE__ */ l(
    "iframe",
    {
      src: E,
      title: n ?? "Embedded video",
      loading: "lazy",
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
      allowFullScreen: !0,
      referrerPolicy: "strict-origin-when-cross-origin",
      className: "absolute inset-0 h-full w-full border-0"
    }
  ) });
}
const na = C({
  label: c().min(1),
  href: c().optional(),
  variant: _(["primary", "secondary", "ghost"]).default("primary"),
  size: _(["sm", "md", "lg"]).default("md"),
  newTab: D().default(!1),
  /** Optional custom event emitted to the tracker on click; defaults to "cta_click". */
  eventName: c().default("cta_click"),
  className: c().optional()
}), sa = {
  sm: "px-4 py-2 text-[13px] gap-1.5",
  md: "px-5 @md:px-6 py-2.5 @md:py-3 text-[14.5px] gap-2",
  lg: "px-6 @md:px-7 py-3 @md:py-3.5 text-[15.5px] gap-2"
}, ia = {
  primary: {
    // Glass/gradient-aware: a themed `surface` emits `--dl-btn-*` so the CTA
    // itself goes frosted / gradient. Every var falls back to the solid brand
    // look, so a flat theme renders exactly as before.
    background: "var(--dl-btn-bg, var(--dl-brand, #2563eb))",
    color: "var(--dl-btn-fg, var(--dl-on-brand, #ffffff))",
    border: "var(--dl-btn-border, none)",
    backdropFilter: "blur(var(--dl-btn-blur, 0px))",
    WebkitBackdropFilter: "blur(var(--dl-btn-blur, 0px))",
    boxShadow: "var(--dl-btn-shadow, var(--dl-shadow, 0 1px 0 0 color-mix(in srgb, var(--dl-on-surface, #000) 8%, transparent), 0 8px 24px -12px color-mix(in srgb, var(--dl-brand, #2563eb) 70%, transparent)))"
  },
  secondary: {
    backgroundColor: "var(--dl-contrast, #0a0a0a)",
    color: "var(--dl-on-contrast, #fafafa)"
  },
  ghost: {
    backgroundColor: "transparent",
    color: "var(--dl-brand, #2563eb)",
    boxShadow: "inset 0 0 0 1px color-mix(in srgb, var(--dl-brand, #2563eb) 35%, transparent)"
  }
};
function oa(a) {
  const {
    label: e,
    href: t,
    variant: r = "primary",
    size: n = "md",
    newTab: s = !1,
    eventName: i = "cta_click",
    className: o
  } = a, u = w(
    "group inline-flex items-center justify-center font-medium transition-transform duration-200 hover:-translate-y-0.5 active:translate-y-0 focus-visible:outline-none focus-visible:ring-2",
    sa[n],
    o
  ), m = {
    ...ia[r],
    borderRadius: "var(--dl-radius, 9999px)",
    fontFamily: "var(--dl-font-body, ui-sans-serif, sans-serif)",
    outlineColor: "var(--dl-brand, #3b82f6)"
  }, g = /* @__PURE__ */ x(We, { children: [
    /* @__PURE__ */ l("span", { "data-dl-edit": "label", children: e }),
    /* @__PURE__ */ l("span", { "aria-hidden": !0, className: "transition-transform duration-200 group-hover:translate-x-1", children: "→" })
  ] });
  return t ? /* @__PURE__ */ l(
    "a",
    {
      "data-node-id": a["data-node-id"],
      href: t,
      target: s ? "_blank" : void 0,
      rel: s ? "noopener noreferrer" : void 0,
      className: u,
      style: m,
      "data-dl-event": i,
      children: g
    }
  ) : /* @__PURE__ */ l(
    "button",
    {
      type: "button",
      "data-node-id": a["data-node-id"],
      className: u,
      style: m,
      "data-dl-event": i,
      children: g
    }
  );
}
const la = C({
  name: c().min(1),
  label: c().min(1),
  type: _(["text", "email", "phone", "number", "date", "checkbox", "select", "textarea"]),
  required: D().default(!1),
  placeholder: c().optional(),
  options: $(c()).optional()
}), da = C({
  formId: c().min(1),
  title: c().optional(),
  description: c().optional(),
  fields: $(la).min(1),
  submitLabel: c().default("Submit"),
  successMessage: c().default("Thanks! We'll be in touch."),
  /** Endpoint the form posts to. Defaults to form-gateway's /f/<formId>. */
  action: c().optional(),
  className: c().optional()
});
function ca(a) {
  const {
    formId: e,
    title: t,
    description: r,
    fields: n,
    submitLabel: s = "Submit",
    successMessage: i = "Thanks! We'll be in touch.",
    action: o,
    className: u
  } = a, [m, g] = ye("idle"), [A, T] = ye(null), O = async (R) => {
    R.preventDefault(), g("submitting"), T(null);
    const E = new FormData(R.currentTarget), U = {};
    for (const [F, z] of E.entries()) U[F] = z;
    const K = (F) => {
      const z = document.cookie.match(new RegExp("(?:^|; )" + F + "=([^;]*)"));
      return z && z[1] ? decodeURIComponent(z[1]) : "";
    }, Le = K("_dl_vid"), ge = K("_dl_exp"), Pe = ge ? ge.split(",").filter(Boolean) : [], Me = typeof document < "u" ? document.documentElement.getAttribute("data-page-id") ?? "" : "", Be = typeof document < "u" ? document.documentElement.getAttribute("data-version-id") ?? "" : "";
    try {
      const F = await fetch(o ?? `/f/${e}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          values: U,
          anti_spam_token: U.cf_turnstile_response ?? "",
          visitor_id: Le,
          page_id: Me,
          version_id: Be,
          exp_assignments: Pe
        }),
        credentials: "include"
      });
      if (!F.ok) {
        const z = await F.json().catch(() => ({}));
        T((z == null ? void 0 : z.message) ?? "Submission failed. Please try again."), g("error");
        return;
      }
      g("success");
    } catch (F) {
      T(F instanceof Error ? F.message : "Network error"), g("error");
    }
  };
  return m === "success" ? /* @__PURE__ */ x(
    "div",
    {
      "data-node-id": a["data-node-id"],
      className: w("rounded-2xl px-6 py-8 max-w-xl", u),
      style: {
        backgroundColor: "color-mix(in srgb, var(--dl-success, #16a34a) 12%, var(--dl-surface, #fff))",
        color: "var(--dl-on-surface, #0a0a0a)",
        border: "1px solid color-mix(in srgb, var(--dl-success, #16a34a) 35%, transparent)"
      },
      children: [
        /* @__PURE__ */ l(
          "div",
          {
            className: "text-[10px] uppercase tracking-[0.2em] mb-2",
            style: { color: "var(--dl-success, #16a34a)", fontFamily: "var(--dl-font-mono, monospace)" },
            children: "✓ Received"
          }
        ),
        /* @__PURE__ */ l("p", { className: "text-base", children: i })
      ]
    }
  ) : /* @__PURE__ */ x(
    "form",
    {
      "data-node-id": a["data-node-id"],
      className: w("max-w-xl", u),
      onSubmit: O,
      noValidate: !0,
      children: [
        t ? /* @__PURE__ */ l(
          "h2",
          {
            className: "text-[1.75rem] @md:text-[2.25rem] tracking-[-0.02em] mb-2",
            style: {
              fontFamily: "var(--dl-font-display, Georgia, serif)",
              fontWeight: 600,
              fontVariationSettings: "'opsz' 90"
            },
            children: t
          }
        ) : null,
        r ? /* @__PURE__ */ l("p", { className: "opacity-70 text-[15px] leading-relaxed", children: r }) : null,
        /* @__PURE__ */ l("div", { className: w("space-y-1", t || r ? "mt-7" : ""), children: n.map((R) => /* @__PURE__ */ l(ua, { field: R }, R.name)) }),
        A ? /* @__PURE__ */ l(
          "p",
          {
            className: "mt-3 text-sm",
            style: { color: "var(--dl-danger, #dc2626)" },
            children: A
          }
        ) : null,
        /* @__PURE__ */ x(
          "button",
          {
            type: "submit",
            disabled: m === "submitting",
            className: "group mt-6 inline-flex items-center gap-2 rounded-full px-6 py-3 font-medium transition-transform hover:-translate-y-0.5 disabled:opacity-60 disabled:translate-y-0",
            style: {
              backgroundColor: "var(--dl-brand, #2563eb)",
              color: "var(--dl-on-brand, #ffffff)",
              boxShadow: "0 1px 0 0 color-mix(in srgb, var(--dl-on-surface, #000) 8%, transparent), 0 8px 28px -12px color-mix(in srgb, var(--dl-brand, #2563eb) 70%, transparent)"
            },
            children: [
              /* @__PURE__ */ l("span", { children: m === "submitting" ? "Sending…" : s }),
              /* @__PURE__ */ l("span", { "aria-hidden": !0, className: "transition-transform duration-200 group-hover:translate-x-1", children: "→" })
            ]
          }
        )
      ]
    }
  );
}
function ua({ field: a }) {
  var n;
  const e = "block w-full bg-transparent border-0 border-b py-2.5 px-0 text-[15.5px] placeholder:opacity-40 focus:outline-none focus:ring-0 transition-[border-color]", t = {
    color: "var(--dl-on-surface, #0a0a0a)",
    borderColor: "color-mix(in srgb, var(--dl-on-surface, #0a0a0a) 18%, transparent)",
    fontFamily: "var(--dl-font-body, ui-sans-serif, sans-serif)"
  }, r = {
    onFocus: (s) => {
      s.currentTarget.style.borderColor = "var(--dl-brand, #2563eb)", s.currentTarget.style.borderBottomWidth = "2px";
    },
    onBlur: (s) => {
      s.currentTarget.style.borderColor = "color-mix(in srgb, var(--dl-on-surface, #0a0a0a) 18%, transparent)", s.currentTarget.style.borderBottomWidth = "1px";
    }
  };
  return a.type === "checkbox" ? /* @__PURE__ */ x("label", { className: "flex items-center gap-2.5 py-3.5", children: [
    /* @__PURE__ */ l(
      "input",
      {
        type: "checkbox",
        name: a.name,
        required: a.required,
        className: "h-4 w-4 rounded",
        style: { accentColor: "var(--dl-brand, #2563eb)" }
      }
    ),
    /* @__PURE__ */ l("span", { className: "text-[14px] opacity-85", children: a.label })
  ] }) : /* @__PURE__ */ x("label", { className: "block py-2.5", children: [
    /* @__PURE__ */ x(
      "span",
      {
        className: "block text-[10.5px] uppercase tracking-[0.16em] opacity-60 mb-0.5",
        style: { fontFamily: "var(--dl-font-mono, monospace)" },
        children: [
          a.label,
          a.required ? /* @__PURE__ */ l("span", { style: { color: "var(--dl-danger, #dc2626)" }, "aria-hidden": "true", children: " *" }) : null
        ]
      }
    ),
    a.type === "textarea" ? /* @__PURE__ */ l(
      "textarea",
      {
        name: a.name,
        required: a.required,
        placeholder: a.placeholder,
        rows: 4,
        className: e + " resize-y",
        style: t,
        ...r
      }
    ) : a.type === "select" ? /* @__PURE__ */ x(
      "select",
      {
        name: a.name,
        required: a.required,
        className: e,
        style: t,
        ...r,
        children: [
          /* @__PURE__ */ l("option", { value: "", children: "Select…" }),
          (n = a.options) == null ? void 0 : n.map((s) => /* @__PURE__ */ l("option", { value: s, children: s }, s))
        ]
      }
    ) : /* @__PURE__ */ l(
      "input",
      {
        type: a.type === "phone" ? "tel" : a.type,
        name: a.name,
        required: a.required,
        placeholder: a.placeholder,
        className: e,
        style: t,
        ...r
      }
    )
  ] });
}
const ma = C({
  label: c().min(1),
  href: c().min(1)
}), fa = C({
  companyName: c().min(1),
  copyright: c().optional(),
  links: $(ma).default([]),
  legalText: c().optional(),
  className: c().optional()
});
function ha(a) {
  const { companyName: e, copyright: t, links: r = [], legalText: n, className: s } = a, i = (/* @__PURE__ */ new Date()).getFullYear(), o = t ?? `© ${i} ${e}. All rights reserved.`;
  return /* @__PURE__ */ l(
    "footer",
    {
      "data-node-id": a["data-node-id"],
      className: w("@container border-t pt-14 @md:pt-20 pb-10", s),
      style: {
        borderTopColor: "color-mix(in srgb, var(--dl-on-surface, #0a0a0a) 12%, transparent)"
      },
      children: /* @__PURE__ */ x("div", { className: "max-w-7xl mx-auto px-5 @md:px-8", children: [
        /* @__PURE__ */ x(
          "div",
          {
            className: "text-[2.5rem] @md:text-[4.5rem] @lg:text-[6rem] leading-[0.95] tracking-[-0.04em] mb-8 @md:mb-12 opacity-90",
            style: {
              fontFamily: "var(--dl-font-display, Georgia, serif)",
              fontWeight: 600,
              fontVariationSettings: "'opsz' 144"
            },
            children: [
              e,
              "."
            ]
          }
        ),
        /* @__PURE__ */ x("div", { className: "grid @md:grid-cols-[1fr_auto] gap-6 items-end", children: [
          r.length > 0 ? /* @__PURE__ */ l("nav", { "aria-label": "Footer", children: /* @__PURE__ */ l("ul", { className: "flex flex-wrap gap-x-7 gap-y-3 text-sm", children: r.map((u) => /* @__PURE__ */ l("li", { children: /* @__PURE__ */ x(
            "a",
            {
              href: u.href,
              className: "group relative inline-block opacity-70 hover:opacity-100 transition-opacity",
              children: [
                u.label,
                /* @__PURE__ */ l(
                  "span",
                  {
                    "aria-hidden": !0,
                    className: "absolute left-0 right-0 -bottom-0.5 h-px scale-x-0 origin-left transition-transform duration-300 group-hover:scale-x-100",
                    style: { backgroundColor: "currentColor" }
                  }
                )
              ]
            }
          ) }, u.href)) }) }) : /* @__PURE__ */ l("span", {}),
          /* @__PURE__ */ l(
            "p",
            {
              className: "text-[10.5px] uppercase tracking-[0.18em] opacity-60",
              style: { fontFamily: "var(--dl-font-mono, monospace)" },
              children: o
            }
          )
        ] }),
        n ? /* @__PURE__ */ l(
          "p",
          {
            className: "mt-10 pt-6 border-t text-[12.5px] leading-relaxed opacity-60 max-w-3xl",
            style: { borderTopColor: "color-mix(in srgb, var(--dl-on-surface, #0a0a0a) 10%, transparent)" },
            children: n
          }
        ) : null
      ] })
    }
  );
}
const pa = C({
  label: c().min(1),
  href: c().min(1)
}), ga = C({
  logoText: c().optional(),
  logoSrc: c().url().optional(),
  links: $(pa).default([]),
  ctaLabel: c().optional(),
  ctaHref: c().optional(),
  sticky: D().default(!0),
  variant: _(["light", "contrast", "transparent"]).default("light"),
  className: c().optional()
}), ya = {
  light: {
    // Translucent surface so a sticky header floats over content with
    // a hint of the section behind it. Cleaner than a hard border.
    backgroundColor: "color-mix(in srgb, var(--dl-surface, #ffffff) 88%, transparent)",
    color: "var(--dl-on-surface, #0a0a0a)",
    backdropFilter: "saturate(140%) blur(10px)",
    WebkitBackdropFilter: "saturate(140%) blur(10px)",
    borderBottomColor: "color-mix(in srgb, var(--dl-on-surface, #0a0a0a) 8%, transparent)"
  },
  contrast: {
    backgroundColor: "color-mix(in srgb, var(--dl-contrast, #0a0a0a) 92%, transparent)",
    color: "var(--dl-on-contrast, #fafafa)",
    backdropFilter: "saturate(140%) blur(10px)",
    WebkitBackdropFilter: "saturate(140%) blur(10px)",
    borderBottomColor: "color-mix(in srgb, var(--dl-on-contrast, #fafafa) 12%, transparent)"
  },
  transparent: {
    backgroundColor: "transparent",
    color: "inherit",
    borderBottomColor: "transparent"
  }
};
function va(a) {
  const {
    logoText: e,
    logoSrc: t,
    links: r = [],
    ctaLabel: n,
    ctaHref: s,
    sticky: i = !0,
    variant: o = "light",
    className: u
  } = a;
  return /* @__PURE__ */ l(
    "header",
    {
      "data-node-id": a["data-node-id"],
      className: w(
        "@container w-full border-b z-30",
        i && "sticky top-0",
        u
      ),
      style: ya[o],
      children: /* @__PURE__ */ x("div", { className: "max-w-7xl mx-auto px-5 @md:px-8 py-3.5 @md:py-4 flex items-center justify-between gap-4", children: [
        /* @__PURE__ */ x(
          "a",
          {
            href: "/",
            className: "flex items-center gap-2.5 whitespace-nowrap",
            children: [
              t ? /* @__PURE__ */ l("img", { src: t, alt: e ?? "Logo", className: "h-7 w-auto" }) : null,
              e ? /* @__PURE__ */ l(
                "span",
                {
                  className: "text-[17px] @md:text-[19px] tracking-[-0.01em]",
                  style: {
                    fontFamily: "var(--dl-font-display, Georgia, serif)",
                    fontWeight: 600,
                    fontVariationSettings: "'opsz' 144"
                  },
                  children: e
                }
              ) : null
            ]
          }
        ),
        r.length > 0 ? /* @__PURE__ */ l("nav", { "aria-label": "Primary", className: "hidden @md:block", children: /* @__PURE__ */ l("ul", { className: "flex items-center gap-7 text-[13.5px]", children: r.map((m) => /* @__PURE__ */ l("li", { children: /* @__PURE__ */ x(
          "a",
          {
            href: m.href,
            className: "group relative inline-block whitespace-nowrap py-1 transition-opacity hover:opacity-100 opacity-80",
            children: [
              m.label,
              /* @__PURE__ */ l(
                "span",
                {
                  "aria-hidden": !0,
                  className: "absolute left-0 right-0 -bottom-0.5 h-px scale-x-0 origin-left transition-transform duration-300 group-hover:scale-x-100",
                  style: { backgroundColor: "currentColor" }
                }
              )
            ]
          }
        ) }, m.href)) }) }) : null,
        n && s ? /* @__PURE__ */ x(
          "a",
          {
            href: s,
            className: "group inline-flex items-center gap-1.5 rounded-full px-4 py-1.5 text-sm font-medium transition-transform hover:-translate-y-0.5 whitespace-nowrap",
            style: {
              backgroundColor: "var(--dl-brand, #2563eb)",
              color: "var(--dl-on-brand, #ffffff)",
              boxShadow: "0 6px 18px -10px color-mix(in srgb, var(--dl-brand, #2563eb) 80%, transparent)"
            },
            children: [
              /* @__PURE__ */ l("span", { children: n }),
              /* @__PURE__ */ l("span", { "aria-hidden": !0, className: "transition-transform group-hover:translate-x-0.5", children: "→" })
            ]
          }
        ) : null
      ] })
    }
  );
}
const xa = C({
  value: c().min(1),
  label: c().min(1)
}), ba = C({
  heading: c().optional(),
  items: $(xa).min(1).default([]),
  align: _(["left", "center"]).default("left"),
  className: c().optional()
});
function _a(a) {
  const { heading: e, items: t = [], align: r = "left", className: n } = a;
  return /* @__PURE__ */ x(
    "div",
    {
      "data-node-id": a["data-node-id"],
      className: w("@container px-5 @md:px-8 py-14 @md:py-20", r === "center" && "text-center", n),
      children: [
        e ? /* @__PURE__ */ l(
          "h2",
          {
            className: "max-w-3xl text-[calc(1.5rem*var(--dl-font-scale,1))] @md:text-[calc(2.25rem*var(--dl-font-scale,1))] @lg:text-[calc(2.75rem*var(--dl-font-scale,1))] tracking-[-0.02em] mb-8 @md:mb-12 leading-[1.1]",
            style: {
              fontFamily: "var(--dl-font-display, Georgia, serif)",
              fontWeight: 600,
              fontVariationSettings: "'opsz' 100"
            },
            children: e
          }
        ) : null,
        /* @__PURE__ */ l(
          "dl",
          {
            className: w(
              "grid",
              t.length >= 4 ? "grid-cols-2 @md:grid-cols-4" : "grid-cols-1 @md:grid-cols-3"
            ),
            style: {
              // Editorial rule lines between cells; --dl-on-surface at 12%.
              rowGap: 0,
              columnGap: 0
            },
            children: t.map((s, i) => /* @__PURE__ */ x(
              "div",
              {
                className: "relative px-5 py-7",
                style: {
                  borderTopWidth: "var(--dl-border-width, 1px)",
                  borderTopStyle: "solid",
                  borderTopColor: "var(--dl-border-color, color-mix(in srgb, var(--dl-on-surface, #0a0a0a) 12%, transparent))",
                  borderLeftWidth: i === 0 ? 0 : "var(--dl-border-width, 1px)",
                  borderLeftStyle: "solid",
                  borderLeftColor: "var(--dl-border-color, color-mix(in srgb, var(--dl-on-surface, #0a0a0a) 12%, transparent))"
                },
                children: [
                  /* @__PURE__ */ l(
                    "dt",
                    {
                      className: "text-[calc(2.75rem*var(--dl-font-scale,1))] @md:text-[calc(3.75rem*var(--dl-font-scale,1))] @lg:text-[calc(4.5rem*var(--dl-font-scale,1))] leading-[0.95] tracking-[-0.04em] tabular-nums",
                      style: {
                        fontFamily: "var(--dl-font-display, Georgia, serif)",
                        fontWeight: 600,
                        fontVariationSettings: "'opsz' 144",
                        color: "var(--dl-brand, #2563eb)"
                      },
                      children: s.value
                    }
                  ),
                  /* @__PURE__ */ l(
                    "dd",
                    {
                      className: "mt-3 text-[11px] uppercase tracking-[0.18em] opacity-70",
                      style: { fontFamily: "var(--dl-font-mono, monospace)" },
                      children: s.label
                    }
                  )
                ]
              },
              i
            ))
          }
        )
      ]
    }
  );
}
const ka = C({
  q: c().min(1),
  a: c().min(1)
}), wa = C({
  heading: c().default("Frequently asked questions"),
  items: $(ka).min(1).default([]),
  className: c().optional()
});
function Na(a) {
  const { heading: e, items: t = [], className: r } = a;
  return /* @__PURE__ */ x(
    "div",
    {
      "data-node-id": a["data-node-id"],
      className: w("@container px-5 @md:px-8 py-14 @md:py-20 max-w-4xl mx-auto", r),
      children: [
        e ? /* @__PURE__ */ l(
          "h2",
          {
            className: "text-[1.75rem] @md:text-[2.5rem] tracking-[-0.02em] mb-10 leading-[1.1]",
            style: {
              fontFamily: "var(--dl-font-display, Georgia, serif)",
              fontWeight: 600,
              fontVariationSettings: "'opsz' 100"
            },
            children: e
          }
        ) : null,
        /* @__PURE__ */ l(
          "dl",
          {
            className: "border-t",
            style: {
              borderTopColor: "color-mix(in srgb, var(--dl-on-surface, #0a0a0a) 12%, transparent)"
            },
            children: t.map((n, s) => /* @__PURE__ */ x(
              "details",
              {
                className: "group border-b py-5",
                style: {
                  borderBottomColor: "color-mix(in srgb, var(--dl-on-surface, #0a0a0a) 12%, transparent)"
                },
                children: [
                  /* @__PURE__ */ x("summary", { className: "flex items-baseline gap-5 cursor-pointer list-none [&::-webkit-details-marker]:hidden", children: [
                    /* @__PURE__ */ l(
                      "span",
                      {
                        className: "shrink-0 text-[11px] tracking-[0.16em] opacity-50 mt-1",
                        style: { fontFamily: "var(--dl-font-mono, monospace)" },
                        children: String(s + 1).padStart(2, "0")
                      }
                    ),
                    /* @__PURE__ */ l(
                      "h3",
                      {
                        className: "flex-1 text-[17px] @md:text-[20px] tracking-[-0.01em] leading-snug",
                        style: { fontFamily: "var(--dl-font-display, Georgia, serif)", fontWeight: 500 },
                        children: n.q
                      }
                    ),
                    /* @__PURE__ */ l(
                      "span",
                      {
                        "aria-hidden": !0,
                        className: "shrink-0 text-2xl leading-none select-none transition-transform duration-300 group-open:rotate-45 mt-1",
                        style: { color: "var(--dl-brand, #2563eb)" },
                        children: "+"
                      }
                    )
                  ] }),
                  /* @__PURE__ */ l("p", { className: "mt-4 ml-[3.25rem] opacity-75 text-[15px] leading-relaxed", children: n.a })
                ]
              },
              s
            ))
          }
        )
      ]
    }
  );
}
const Ca = C({
  quote: c().min(1),
  author: c().min(1),
  role: c().optional(),
  avatarSrc: c().url().optional()
}), Sa = C({
  heading: c().optional(),
  items: $(Ca).min(1).default([]),
  layout: _(["grid", "single"]).default("grid"),
  className: c().optional()
});
function Ta(a) {
  const { heading: e, items: t = [], layout: r = "grid", className: n } = a;
  return /* @__PURE__ */ x(
    "div",
    {
      "data-node-id": a["data-node-id"],
      className: w("@container px-5 @md:px-8 py-14 @md:py-20 max-w-7xl mx-auto", n),
      children: [
        e ? /* @__PURE__ */ l(
          "h2",
          {
            className: "text-[calc(1.75rem*var(--dl-font-scale,1))] @md:text-[calc(2.5rem*var(--dl-font-scale,1))] tracking-[-0.02em] mb-10 @md:mb-14 max-w-2xl",
            style: {
              fontFamily: "var(--dl-font-display, Georgia, serif)",
              fontWeight: 600,
              fontVariationSettings: "'opsz' 100"
            },
            children: e
          }
        ) : null,
        /* @__PURE__ */ l(
          "div",
          {
            className: w(
              r === "grid" ? "grid gap-6 @lg:gap-8 @md:grid-cols-3" : "max-w-2xl"
            ),
            children: (r === "single" ? t.slice(0, 1) : t).map((s, i) => /* @__PURE__ */ x(
              "figure",
              {
                className: "relative p-7 @md:p-8",
                style: {
                  background: "var(--dl-surface-gradient, var(--dl-surface-bg, color-mix(in srgb, var(--dl-on-surface, #0a0a0a) 4%, transparent)))",
                  backdropFilter: "blur(var(--dl-surface-blur, 0px))",
                  WebkitBackdropFilter: "blur(var(--dl-surface-blur, 0px))",
                  borderRadius: "var(--dl-radius, 20px)",
                  borderWidth: "var(--dl-border-width, 1px)",
                  borderStyle: "solid",
                  borderColor: "var(--dl-border-color, color-mix(in srgb, var(--dl-on-surface, #0a0a0a) 8%, transparent))",
                  boxShadow: "var(--dl-shadow, none)"
                },
                children: [
                  /* @__PURE__ */ l(
                    "span",
                    {
                      "aria-hidden": !0,
                      className: "absolute -top-3 left-7 text-[2.75rem] leading-none select-none",
                      style: {
                        fontFamily: "var(--dl-font-display, Georgia, serif)",
                        fontStyle: "italic",
                        color: "var(--dl-brand, #2563eb)",
                        opacity: 0.7
                      },
                      children: "“"
                    }
                  ),
                  /* @__PURE__ */ l(
                    "blockquote",
                    {
                      className: "text-[16.5px] @md:text-[18px] leading-[1.55]",
                      style: {
                        fontFamily: "var(--dl-font-display, Georgia, serif)",
                        fontStyle: "italic",
                        fontWeight: 400,
                        fontVariationSettings: "'opsz' 24"
                      },
                      children: s.quote
                    }
                  ),
                  /* @__PURE__ */ x("figcaption", { className: "mt-6 flex items-center gap-3", children: [
                    s.avatarSrc ? /* @__PURE__ */ l("img", { src: s.avatarSrc, alt: "", className: "h-10 w-10 rounded-full object-cover" }) : /* @__PURE__ */ l(
                      "div",
                      {
                        "aria-hidden": !0,
                        className: "h-10 w-10 rounded-full flex items-center justify-center text-sm font-semibold",
                        style: {
                          backgroundColor: "var(--dl-brand, #2563eb)",
                          color: "var(--dl-on-brand, #ffffff)"
                        },
                        children: s.author.slice(0, 1)
                      }
                    ),
                    /* @__PURE__ */ x("div", { className: "leading-tight", children: [
                      /* @__PURE__ */ l("div", { className: "font-medium text-[14px]", children: s.author }),
                      s.role ? /* @__PURE__ */ l(
                        "div",
                        {
                          className: "text-[10.5px] uppercase tracking-[0.16em] opacity-60 mt-0.5",
                          style: { fontFamily: "var(--dl-font-mono, monospace)" },
                          children: s.role
                        }
                      ) : null
                    ] })
                  ] })
                ]
              },
              i
            ))
          }
        )
      ]
    }
  );
}
const Aa = C({
  name: c().min(1),
  price: c().min(1),
  priceDetail: c().optional(),
  features: $(c()).default([]),
  ctaLabel: c().default("Choose"),
  ctaHref: c().min(1),
  highlighted: D().default(!1)
}), Oa = C({
  heading: c().optional(),
  subheading: c().optional(),
  tiers: $(Aa).min(1).default([]),
  className: c().optional()
});
function Ra(a) {
  const { heading: e, subheading: t, tiers: r = [], className: n } = a;
  return /* @__PURE__ */ x(
    "div",
    {
      "data-node-id": a["data-node-id"],
      className: w("@container px-5 @md:px-8 py-14 @md:py-20 max-w-7xl mx-auto", n),
      children: [
        /* @__PURE__ */ x("div", { className: "max-w-2xl mb-12 @md:mb-16", children: [
          e ? /* @__PURE__ */ l(
            "h2",
            {
              className: "text-[calc(1.75rem*var(--dl-font-scale,1))] @md:text-[calc(2.5rem*var(--dl-font-scale,1))] @lg:text-[calc(3rem*var(--dl-font-scale,1))] tracking-[-0.02em] leading-[1.1]",
              style: {
                fontFamily: "var(--dl-font-display, Georgia, serif)",
                fontWeight: 600,
                fontVariationSettings: "'opsz' 100"
              },
              children: e
            }
          ) : null,
          t ? /* @__PURE__ */ l("p", { className: "mt-3 opacity-70 text-[15.5px] leading-relaxed", children: t }) : null
        ] }),
        /* @__PURE__ */ l("div", { className: w("grid gap-5 @lg:gap-6", r.length >= 3 ? "@md:grid-cols-3" : "@md:grid-cols-2"), children: r.map((s, i) => /* @__PURE__ */ x(
          "div",
          {
            className: w(
              "relative p-7 @md:p-8 flex flex-col transition-transform hover:-translate-y-1",
              s.highlighted && "scale-[1.02]"
            ),
            style: {
              background: s.highlighted ? "var(--dl-brand, #2563eb)" : "var(--dl-surface-gradient, var(--dl-surface-bg, color-mix(in srgb, var(--dl-on-surface, #0a0a0a) 3%, transparent)))",
              color: s.highlighted ? "var(--dl-on-brand, #ffffff)" : "var(--dl-on-surface, #0a0a0a)",
              backdropFilter: s.highlighted ? void 0 : "blur(var(--dl-surface-blur, 0px))",
              WebkitBackdropFilter: s.highlighted ? void 0 : "blur(var(--dl-surface-blur, 0px))",
              borderRadius: "var(--dl-radius, 20px)",
              borderWidth: "var(--dl-border-width, 1px)",
              borderStyle: "solid",
              borderColor: s.highlighted ? "transparent" : "var(--dl-border-color, color-mix(in srgb, var(--dl-on-surface, #0a0a0a) 10%, transparent))",
              boxShadow: s.highlighted ? "var(--dl-shadow, 0 30px 60px -25px color-mix(in srgb, var(--dl-brand, #2563eb) 60%, transparent))" : "var(--dl-shadow, none)"
            },
            children: [
              s.highlighted ? /* @__PURE__ */ l(
                "span",
                {
                  className: "absolute -top-2.5 right-7 text-[10px] uppercase tracking-[0.18em] px-2.5 py-1 rounded-full",
                  style: {
                    backgroundColor: "var(--dl-on-brand, #ffffff)",
                    color: "var(--dl-brand, #2563eb)",
                    fontFamily: "var(--dl-font-mono, monospace)",
                    fontWeight: 500
                  },
                  children: "Recommended"
                }
              ) : null,
              /* @__PURE__ */ l(
                "div",
                {
                  className: "text-[10.5px] uppercase tracking-[0.18em] opacity-70",
                  style: { fontFamily: "var(--dl-font-mono, monospace)" },
                  children: s.name
                }
              ),
              /* @__PURE__ */ x("div", { className: "mt-4 flex items-baseline gap-1.5", children: [
                /* @__PURE__ */ l(
                  "span",
                  {
                    className: "text-[calc(3rem*var(--dl-font-scale,1))] @md:text-[calc(3.5rem*var(--dl-font-scale,1))] leading-none tracking-[-0.03em] tabular-nums",
                    style: {
                      fontFamily: "var(--dl-font-display, Georgia, serif)",
                      fontWeight: 600,
                      fontVariationSettings: "'opsz' 144"
                    },
                    children: s.price
                  }
                ),
                s.priceDetail ? /* @__PURE__ */ l("span", { className: "text-sm opacity-70", children: s.priceDetail }) : null
              ] }),
              /* @__PURE__ */ l("ul", { className: "mt-7 space-y-2.5 text-[14.5px] flex-1", children: s.features.map((o, u) => /* @__PURE__ */ x("li", { className: "flex gap-2.5", children: [
                /* @__PURE__ */ l("span", { "aria-hidden": !0, className: "opacity-70 mt-0.5", children: "→" }),
                /* @__PURE__ */ l("span", { className: "opacity-90 leading-relaxed", children: o })
              ] }, u)) }),
              /* @__PURE__ */ x(
                "a",
                {
                  href: s.ctaHref,
                  className: "group mt-7 inline-flex items-center justify-between px-5 py-3 text-[14px] font-medium transition-transform hover:-translate-y-0.5",
                  style: s.highlighted ? (
                    // Inverted button on the brand-filled featured card — deliberate
                    // high contrast; left solid so it reads against the brand card.
                    { backgroundColor: "var(--dl-on-brand, #ffffff)", color: "var(--dl-brand, #2563eb)", borderRadius: "var(--dl-radius, 9999px)" }
                  ) : (
                    // Standard brand CTA — glass/gradient-aware via --dl-btn-*.
                    {
                      background: "var(--dl-btn-bg, var(--dl-brand, #2563eb))",
                      color: "var(--dl-btn-fg, var(--dl-on-brand, #ffffff))",
                      border: "var(--dl-btn-border, none)",
                      backdropFilter: "blur(var(--dl-btn-blur, 0px))",
                      WebkitBackdropFilter: "blur(var(--dl-btn-blur, 0px))",
                      borderRadius: "var(--dl-radius, 9999px)"
                    }
                  ),
                  children: [
                    /* @__PURE__ */ l("span", { children: s.ctaLabel }),
                    /* @__PURE__ */ l("span", { "aria-hidden": !0, className: "transition-transform group-hover:translate-x-1", children: "→" })
                  ]
                }
              )
            ]
          },
          i
        )) })
      ]
    }
  );
}
const Ia = C({
  src: c().url(),
  alt: c().min(1),
  href: c().optional()
}), Za = C({
  caption: c().optional(),
  logos: $(Ia).min(1).default([]),
  className: c().optional()
});
function ja(a) {
  const { caption: e, logos: t = [], className: r } = a;
  return /* @__PURE__ */ x(
    "div",
    {
      "data-node-id": a["data-node-id"],
      className: w("@container px-5 @md:px-8 py-12 @md:py-16 max-w-7xl mx-auto", r),
      children: [
        e ? /* @__PURE__ */ l(
          "p",
          {
            className: "text-[10.5px] uppercase tracking-[0.22em] mb-7 opacity-60 text-center",
            style: { fontFamily: "var(--dl-font-mono, monospace)" },
            children: e
          }
        ) : null,
        /* @__PURE__ */ l("div", { className: "flex flex-wrap items-center justify-center gap-x-10 @md:gap-x-14 gap-y-7 opacity-75", children: t.map((n, s) => {
          const i = /* @__PURE__ */ l(
            "img",
            {
              src: n.src,
              alt: n.alt,
              className: "h-7 @md:h-8 w-auto grayscale opacity-80 hover:grayscale-0 hover:opacity-100 transition duration-300",
              loading: "lazy"
            }
          );
          return n.href ? /* @__PURE__ */ l("a", { href: n.href, "aria-label": n.alt, children: i }, s) : /* @__PURE__ */ l("span", { children: i }, s);
        }) })
      ]
    }
  );
}
const Ve = {
  Header: {
    name: "Header",
    version: "0.1.0",
    component: va,
    schema: ga,
    acceptsChildren: !1,
    description: "Top navigation: logo + links + optional CTA. Sticky by default."
  },
  Section: {
    name: "Section",
    version: "0.1.0",
    component: _t,
    schema: gt,
    acceptsChildren: !0,
    description: "A semantic <section> with background and spacing controls."
  },
  Container: {
    name: "Container",
    version: "0.1.0",
    component: Ct,
    schema: kt,
    acceptsChildren: !0,
    description: "Centered content wrapper with max-width + padding."
  },
  Grid: {
    name: "Grid",
    version: "0.1.0",
    component: Rt,
    schema: St,
    acceptsChildren: !0,
    description: "Responsive CSS grid (2/3/4/6 columns) that collapses to 1 column on narrow screens. Children may set colSpan/rowSpan for asymmetric layouts."
  },
  Columns: {
    name: "Columns",
    version: "0.1.0",
    component: $t,
    schema: It,
    acceptsChildren: !0,
    description: "Simple equal-width N-column row (2/3/4) that collapses to 1 column on narrow screens."
  },
  Hero: {
    name: "Hero",
    version: "0.1.0",
    component: zt,
    schema: Et,
    acceptsChildren: !1,
    description: "Above-the-fold headline + subline + primary CTA."
  },
  MeshGradientBg: {
    name: "MeshGradientBg",
    version: "0.1.0",
    component: Bt,
    schema: Lt,
    acceptsChildren: !0,
    description: "Decorative section with a soft theme-colored mesh-gradient backdrop; place a Hero or content inside it."
  },
  Text: {
    name: "Text",
    version: "0.1.0",
    component: Jt,
    schema: Gt,
    acceptsChildren: !1,
    description: "Paragraph or heading text with basic typographic controls."
  },
  Prose: {
    name: "Prose",
    version: "0.1.0",
    component: Ut,
    schema: Wt,
    acceptsChildren: !1,
    description: "Long-form article body from a markdown subset (#/##/### headings, paragraphs, - lists). Themed via the Typography plugin — use for editorial/blog content."
  },
  Image: {
    name: "Image",
    version: "0.1.0",
    component: Kt,
    schema: Qt,
    acceptsChildren: !1,
    description: "Responsive image with srcset and alt-text (required)."
  },
  Video: {
    name: "Video",
    version: "0.1.0",
    component: ra,
    schema: ea,
    acceptsChildren: !1,
    description: "Responsive video embed — YouTube/Vimeo or MP4 — locked to an aspect ratio."
  },
  CTAButton: {
    name: "CTAButton",
    version: "0.1.0",
    component: oa,
    schema: na,
    acceptsChildren: !1,
    description: "Primary/secondary call-to-action button or link."
  },
  Form: {
    name: "Form",
    version: "0.1.0",
    component: ca,
    schema: da,
    acceptsChildren: !1,
    description: "Lead-capture form rendered from a per-form config."
  },
  Footer: {
    name: "Footer",
    version: "0.1.0",
    component: ha,
    schema: fa,
    acceptsChildren: !1,
    description: "Site footer with links, copyright, and legal disclosures."
  },
  Stats: {
    name: "Stats",
    version: "0.1.0",
    component: _a,
    schema: ba,
    acceptsChildren: !1,
    description: "Numeric callouts (e.g. '500k customers · 2024')."
  },
  FAQ: {
    name: "FAQ",
    version: "0.1.0",
    component: Na,
    schema: wa,
    acceptsChildren: !1,
    description: "Accordion of frequently asked questions."
  },
  Testimonials: {
    name: "Testimonials",
    version: "0.1.0",
    component: Ta,
    schema: Sa,
    acceptsChildren: !1,
    description: "Customer quotes with names, roles, and avatars."
  },
  Pricing: {
    name: "Pricing",
    version: "0.1.0",
    component: Ra,
    schema: Oa,
    acceptsChildren: !1,
    description: "Pricing tiers with feature lists and per-tier CTAs."
  },
  LogoBar: {
    name: "LogoBar",
    version: "0.1.0",
    component: ja,
    schema: Za,
    acceptsChildren: !1,
    description: "Row of customer/partner logos for social proof."
  }
}, Fa = Object.keys(Ve);
function za(a) {
  return Ve[a];
}
export {
  oa as C,
  ha as F,
  Rt as G,
  zt as H,
  Kt as I,
  Bt as M,
  Ut as P,
  _t as S,
  Jt as T,
  ra as V,
  na as a,
  $t as b,
  It as c,
  Ct as d,
  kt as e,
  ma as f,
  fa as g,
  ca as h,
  la as i,
  da as j,
  St as k,
  Et as l,
  Qt as m,
  Lt as n,
  Wt as o,
  gt as p,
  Gt as q,
  ea as r,
  za as s,
  Ve as t,
  Fa as u
};
